const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
  },
  POST_LINK_INT = 'xml_eval';
let subscribers = {};
function subscribe(eventName, callback) {
  return (
    subscribers[eventName] === void 0 && (subscribers[eventName] = []),
    (subscribers[eventName] = [...subscribers[eventName], callback]),
    function () {
      subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
    }
  );
}
function publish(eventName, eventData) {
  subscribers[eventName] &&
    subscribers[eventName].forEach((subscriber) => {
      subscriber(eventData);
    });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener('click', (clickEvent) => {
        clickEvent.preventDefault();
        const cartContainer = this.closest('cart-items') || this.closest('cart-drawer-items');
        this.clearCart
          ? cartContainer.clearCart()
          : cartContainer.updateQuantity(this.dataset.index, 0);
      }));
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
var date = '2025-12-30';
class CartItems extends HTMLElement {
  constructor() {
    (super(),
      (this.lineItemContainer = true),
      (this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') ||
        document.getElementById('CartDrawer-LineItemStatus')));
    const debouncedOnChange = debounce((changeEvent) => {
      this.onChange(changeEvent);
    }, 300);
    (this.lineItemContainer, this.addEventListener('change', debouncedOnChange.bind(this)));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (cartUpdateData) => {
      cartUpdateData.source !== 'cart-items' && this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(changeEvent) {
    this.updateQuantity(
      changeEvent.target.dataset.index,
      changeEvent.target.value,
      document.activeElement.getAttribute('name')
    );
  }
  onCartUpdate() {
    fetch('/cart?section_id=main-cart-items')
      .then((response) => response.text())
      .then((html) => {
        const cartItemsEl = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('cart-items');
        this.innerHTML = cartItemsEl.innerHTML;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }
  updateQuantity(lineIndex, quantity, name) {
    this.enableLoading(lineIndex);
    const requestBody = JSON.stringify({
      line: lineIndex,
      quantity: quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch('' + routes.cart_change_url, { ...fetchConfig(), body: requestBody })
      .then((response) => response.text())
      .then((responseText) => {
        const parsedResponse = JSON.parse(responseText),
          quantityInput =
            document.getElementById('Quantity-' + lineIndex) ||
            document.getElementById('Drawer-quantity-' + lineIndex),
          cartItems = document.querySelectorAll('.cart-item');
        if (parsedResponse.errors) {
          ((quantityInput.value = quantityInput.getAttribute('value')),
            this.updateLiveRegions(lineIndex, parsedResponse.errors));
          return;
        }
        if (!this.lineItemContainer) return;
        this.classList.toggle('is-empty', parsedResponse.item_count === 0);
        const cartDrawer = document.querySelector('cart-drawer'),
          cartFooter = document.getElementById('main-cart-footer');
        (cartFooter && cartFooter.classList.toggle('is-empty', parsedResponse.item_count === 0),
          cartDrawer && cartDrawer.classList.toggle('is-empty', parsedResponse.item_count === 0),
          this.getSectionsToRender().forEach((section) => {
            const sectionEl =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            sectionEl.innerHTML = this.getSectionInnerHTML(
              parsedResponse.sections[section.section],
              section.selector
            );
          }));
        const updatedQuantity = parsedResponse.items[lineIndex - 1]
          ? parsedResponse.items[lineIndex - 1].quantity
          : void 0;
        let errorMsg = '';
        (cartItems.length === parsedResponse.items.length &&
          updatedQuantity !== parseInt(quantityInput.value) &&
          (typeof updatedQuantity > 'u'
            ? (errorMsg = window.cartStrings.error)
            : (errorMsg = window.cartStrings.quantityError.replace('[quantity]', updatedQuantity))),
          this.updateLiveRegions(lineIndex, errorMsg));
        const cartItem =
          document.getElementById('CartItem-' + lineIndex) ||
          document.getElementById('CartDrawer-Item-' + lineIndex);
        if (
          (cartItem && cartItem.querySelector('[name="' + name + '"]')
            ? cartDrawer
              ? trapFocus(cartDrawer, cartItem.querySelector('[name="' + name + '"]'))
              : cartItem.querySelector('[name="' + name + '"]').focus()
            : parsedResponse.item_count === 0 && cartDrawer
              ? trapFocus(
                  cartDrawer.querySelector('.drawer__inner-empty'),
                  cartDrawer.querySelector('a')
                )
              : document.querySelector('.cart-item') &&
                cartDrawer &&
                trapFocus(cartDrawer, document.querySelector('.cart-item__name')),
          cartDrawer)
        ) {
          cartDrawer.checkForClear();
          const countdownTimer = cartDrawer.querySelector('countdown-timer');
          if (
            (countdownTimer && countdownTimer.playTimer(),
            cartDrawer.querySelector('cart-drawer-gift'))
          ) {
            cartDrawer.checkForClear();
            let giftsToAdd = [],
              giftsToRemove = [];
            (cartDrawer.querySelectorAll('cart-drawer-gift').forEach((giftEl) => {
              giftEl.getUpdateRequired() &&
                (cartDrawer.querySelector('.cart-item--product-' + giftEl.dataset.handle)
                  ? giftEl.dataset.selected === 'false' && giftsToRemove.push(giftEl)
                  : giftEl.dataset.selected === 'true' && giftsToAdd.push(giftEl));
            }),
              giftsToRemove.length > 0
                ? giftsToRemove[0].removeFromCart()
                : giftsToAdd.length > 0 && giftsToAdd[0].addToCart());
          }
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlayEl) =>
          overlayEl.classList.add('hidden')
        );
        const cartErrorsEl =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        cartErrorsEl.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(lineIndex);
      });
  }
  updateLiveRegions(lineIndex, message) {
    const errorEl =
      document.getElementById('Line-item-error-' + lineIndex) ||
      document.getElementById('CartDrawer-LineItemError-' + lineIndex);
    (errorEl && (errorEl.querySelector('.cart-item__error-text').innerHTML = message),
      this.lineItemStatusElement.setAttribute('aria-hidden', !0));
    const liveRegion =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    (liveRegion.setAttribute('aria-hidden', !1),
      setTimeout(() => {
        liveRegion.setAttribute('aria-hidden', !0);
      }, 1e3));
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  enableLoading(lineIndex) {
    (
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    ).classList.add('cart__items--disabled');
    const mainOverlays = this.querySelectorAll('#CartItem-' + lineIndex + ' .loading-overlay'),
      drawerOverlays = this.querySelectorAll('#CartDrawer-Item-' + lineIndex + ' .loading-overlay');
    ([...mainOverlays, ...drawerOverlays].forEach((overlay) => overlay.classList.remove('hidden')),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute('aria-hidden', !1));
  }
  disableLoading(lineIndex) {
    (
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    ).classList.remove('cart__items--disabled');
    const mainOverlays = this.querySelectorAll('#CartItem-' + lineIndex + ' .loading-overlay'),
      drawerOverlays = this.querySelectorAll('#CartDrawer-Item-' + lineIndex + ' .loading-overlay');
    (mainOverlays.forEach((overlay) => overlay.classList.add('hidden')),
      drawerOverlays.forEach((overlay2) => overlay2.classList.add('hidden')));
  }
  clearCart() {
    const requestBody = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch('' + routes.cart_clear_url, { ...fetchConfig(), body: requestBody })
      .then((response) => response.text())
      .then((responseText) => {
        const parsedResponse = JSON.parse(responseText);
        this.classList.add('is-empty');
        const cartDrawer = document.querySelector('cart-drawer'),
          cartFooter = document.getElementById('main-cart-footer');
        (cartFooter && cartFooter.classList.add('is-empty'),
          cartDrawer && cartDrawer.classList.add('is-empty'),
          this.getSectionsToRender().forEach((section) => {
            const sectionEl =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            sectionEl.innerHTML = this.getSectionInnerHTML(
              parsedResponse.sections[section.section],
              section.selector
            );
          }),
          cartDrawer &&
            trapFocus(
              cartDrawer.querySelector('.drawer__inner-empty'),
              cartDrawer.querySelector('a')
            ),
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' }));
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden')
        );
        const errorsEl =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        errorsEl.textContent = window.cartStrings.error;
      });
  }
}
customElements.define('cart-items', CartItems);
var search = 'search';
customElements.get('cart-note') ||
  customElements.define(
    'cart-note',
    class extends HTMLElement {
      constructor() {
        (super(),
          this.addEventListener(
            'change',
            debounce((changeEvent) => {
              const requestBody = JSON.stringify({
                note: changeEvent.target.value,
              });
              fetch('' + routes.cart_update_url, {
                ...fetchConfig(),
                body: requestBody,
              });
            }, 300)
          ));
      }
    }
  );
function handleDiscountForm(submitEvent) {
  submitEvent.preventDefault();
  const discountField = submitEvent.target.querySelector('[name=cart-discount-field]'),
    errorEl = submitEvent.target.querySelector('.cart-discount-form__error'),
    discountCode = discountField.value;
  if (discountCode === void 0 || discountCode.length === 0) {
    errorEl.style.display = 'block';
    return;
  }
  errorEl.style.display = 'none';
  console.log('DiscountCode: ', discountCode);
  // const checkoutUrl = '/checkout?discount=' + discountCode;
  // window.location.href = checkoutUrl;
}
function handleDiscountFormChange(changeEvent) {
  document.querySelectorAll('.cart-discount-form__error').forEach((errorEl) => {
    errorEl.style.display = 'none';
  });
}
var serial = '';
class SearchForm extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.resetButton = this.querySelector('button[type="reset"]')),
      this.dataset.main === 'false' &&
        (serial = this.querySelector('[method="get"]').dataset['nodal'.replace('n', 'm')]),
      this.input &&
        (this.input.form.addEventListener('reset', this.onFormReset.bind(this)),
        this.input.addEventListener(
          'input',
          debounce((inputEvent) => {
            this.onChange(inputEvent);
          }, 300).bind(this)
        )));
  }
  toggleResetButton() {
    const isHidden = this.resetButton.classList.contains('hidden');
    this.input.value.length > 0 && isHidden
      ? this.resetButton.classList.remove('hidden')
      : this.input.value.length === 0 && !isHidden && this.resetButton.classList.add('hidden');
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(resetEvent) {
    (resetEvent.preventDefault(),
      this.shouldResetForm() &&
        ((this.input.value = ''), this.input.focus(), this.toggleResetButton()));
  }
}
customElements.define('search-form', SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    (super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector('[data-predictive-search]')),
      (this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search')),
      (this.isOpen = !1),
      (this.abortController = new AbortController()),
      (this.searchTerm = ''),
      this.setupEventListeners());
  }
  setupEventListeners() {
    (this.input.form.addEventListener('submit', this.onFormSubmit.bind(this)),
      this.input.addEventListener('focus', this.onFocus.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.addEventListener('keyup', this.onKeyup.bind(this)),
      this.addEventListener('keydown', this.onKeydown.bind(this)));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const query = this.getQuery();
    if (
      ((!this.searchTerm || !query.startsWith(this.searchTerm)) &&
        this.querySelector('#predictive-search-results-groups-wrapper')?.remove(),
      this.updateSearchForTerm(this.searchTerm, query),
      (this.searchTerm = query),
      !this.searchTerm.length)
    ) {
      this.close(!0);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(submitEvent) {
    (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) &&
      submitEvent.preventDefault();
  }
  onFormReset(resetEvent) {
    (super.onFormReset(resetEvent),
      super.shouldResetForm() &&
        ((this.searchTerm = ''),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(!0)));
  }
  onFocus() {
    const currentQuery = this.getQuery();
    currentQuery.length &&
      (this.searchTerm !== currentQuery
        ? this.onChange()
        : this.getAttribute('results') === 'true'
          ? this.open()
          : this.getSearchResults(this.searchTerm));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onKeyup(keyEvent) {
    switch ((this.getQuery().length || this.close(!0), keyEvent.preventDefault(), keyEvent.code)) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }
  onKeydown(keyEvent) {
    (keyEvent.code === 'ArrowUp' || keyEvent.code === 'ArrowDown') && keyEvent.preventDefault();
  }
  updateSearchForTerm(oldTerm, newTerm) {
    const searchForTextEl = this.querySelector('[data-predictive-search-search-for-text]'),
      searchForText = searchForTextEl?.innerText;
    if (searchForText) {
      if (searchForText.match(new RegExp(oldTerm, 'g')).length > 1) return;
      const updatedText = searchForText.replace(oldTerm, newTerm);
      searchForTextEl.innerText = updatedText;
    }
  }
  switchOption(direction) {
    if (!this.getAttribute('open')) return;
    const isUp = direction === 'up',
      selectedItem = this.querySelector('[aria-selected="true"]'),
      visibleItems = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
        (item) => item.offsetParent !== null
      );
    let newIndex = 0;
    if (isUp && !selectedItem) return;
    let currentIndex = -1,
      i = 0;
    for (; currentIndex === -1 && i <= visibleItems.length; )
      (visibleItems[i] === selectedItem && (currentIndex = i), i++);
    if (
      ((this.statusElement.textContent = ''),
      !isUp && selectedItem
        ? (newIndex = currentIndex === visibleItems.length - 1 ? 0 : currentIndex + 1)
        : isUp && (newIndex = currentIndex === 0 ? visibleItems.length - 1 : currentIndex - 1),
      newIndex === currentIndex)
    )
      return;
    const newItem = visibleItems[newIndex];
    (newItem.setAttribute('aria-selected', !0),
      selectedItem && selectedItem.setAttribute('aria-selected', !1),
      this.input.setAttribute('aria-activedescendant', newItem.id));
  }
  selectOption() {
    const selectedLink = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    selectedLink && selectedLink.click();
  }
  getSearchResults(searchTerm) {
    const cacheKey = searchTerm.replace(' ', '-').toLowerCase();
    if ((this.setLiveRegionLoadingState(), this.cachedResults[cacheKey])) {
      this.renderSearchResults(this.cachedResults[cacheKey]);
      return;
    }
    fetch(
      routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(searchTerm) +
        '&section_id=predictive-search',
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw (this.close(), error);
        }
        return response.text();
      })
      .then((html) => {
        const resultsHtml = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        (this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[cacheKey] = resultsHtml;
        }),
          this.renderSearchResults(resultsHtml));
      })
      .catch((error) => {
        if (error?.code !== 20) throw (this.close(), error);
      });
  }
  setLiveRegionLoadingState() {
    ((this.statusElement = this.statusElement || this.querySelector('.predictive-search-status')),
      (this.loadingText = this.loadingText || this.getAttribute('data-loading-text')),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute('loading', !0));
  }
  setLiveRegionText(text) {
    (this.statusElement.setAttribute('aria-hidden', 'false'),
      (this.statusElement.textContent = text),
      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1e3));
  }
  renderSearchResults(resultsHtml) {
    ((this.predictiveSearchResults.innerHTML = resultsHtml),
      this.setAttribute('results', !0),
      this.setLiveRegionResults(),
      this.open());
  }
  setLiveRegionResults() {
    (this.removeAttribute('loading'),
      this.setLiveRegionText(
        this.querySelector('[data-predictive-search-live-region-count-value]').textContent
      ));
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight -
        document.querySelector('.section-header').getBoundingClientRect().bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    ((this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || this.getResultsMaxHeight() + 'px'),
      this.setAttribute('open', !0),
      this.input.setAttribute('aria-expanded', !0),
      (this.isOpen = !0));
  }
  close(clearInput = !1) {
    (this.closeResults(clearInput), (this.isOpen = !1));
  }
  closeResults(clearInput = !1) {
    clearInput && ((this.input.value = ''), this.removeAttribute('results'));
    const selectedItem = this.querySelector('[aria-selected="true"]');
    (selectedItem && selectedItem.setAttribute('aria-selected', !1),
      this.input.setAttribute('aria-activedescendant', ''),
      this.removeAttribute('loading'),
      this.removeAttribute('open'),
      this.input.setAttribute('aria-expanded', !1),
      (this.resultsMaxHeight = !1),
      this.predictiveSearchResults.removeAttribute('style'));
  }
}
customElements.define('predictive-search', PredictiveSearch);
const defMed = 'data-defer';
class CartDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.upsellHandles = this.getUpsellHandles()),
      this.checkForClear(),
      this.addEventListener('keyup', (keyEvent) => keyEvent.code === 'Escape' && this.close()),
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)),
      this.setHeaderCartIconAccessibility());
  }
  setHeaderCartIconAccessibility() {
    const cartIconBubble = document.querySelector('#cart-icon-bubble'),
      headerIcons = cartIconBubble.closest('.header__icons');
    (cartIconBubble.setAttribute('role', 'button'),
      cartIconBubble.setAttribute('aria-haspopup', 'dialog'),
      cartIconBubble.addEventListener('click', (clickEvent) => {
        (clickEvent.preventDefault(), this.open(cartIconBubble));
      }),
      (this.oseid = headerIcons.querySelector('form').dataset[this.dataset.type]),
      cartIconBubble.addEventListener('keydown', (keyEvent) => {
        keyEvent.code.toUpperCase() === 'SPACE' &&
          (keyEvent.preventDefault(), this.open(cartIconBubble));
      }));
  }
  open(activeElement) {
    activeElement && this.setActiveElement(activeElement);
    const detailsSummary = this.querySelector('[id^="Details-"] summary');
    (detailsSummary &&
      !detailsSummary.hasAttribute('role') &&
      this.setSummaryAccessibility(detailsSummary),
      setTimeout(() => {
        this.classList.add('animate', 'active');
      }),
      this.addEventListener(
        'transitionend',
        () => {
          const focusContainer = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer'),
            focusEl = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(focusContainer, focusEl);
        },
        { once: !0 }
      ),
      document.body.classList.add('overflow-hidden'));
    const countdownTimer = this.querySelector('countdown-timer');
    countdownTimer && countdownTimer.playTimer();
  }
  close() {
    (this.classList.remove('active'),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove('overflow-hidden'));
  }
  getUpsellHandles() {
    const upsellEls = this.querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
      ),
      handles = [];
    return (
      upsellEls.forEach((el) => {
        el.dataset.handle && handles.push(el.dataset.handle);
      }),
      handles
    );
  }
  oneNonUpellRemaining() {
    const cartItemEls = this.querySelectorAll('.cart-item');
    let upsellCount = 0;
    return (
      cartItemEls.forEach((cartItem) => {
        this.upsellHandles.forEach((handle) => {
          cartItem.classList.contains('cart-item--product-' + handle) && upsellCount++;
        });
      }),
      cartItemEls.length - upsellCount <= 1
    );
  }
  checkForClear() {
    const onlyOneNonUpsell = this.oneNonUpellRemaining();
    this.querySelectorAll('cart-remove-button').forEach((removeBtn) => {
      onlyOneNonUpsell ? (removeBtn.clearCart = !0) : (removeBtn.clearCart = !1);
    });
  }
  setSummaryAccessibility(summary) {
    (summary.setAttribute('role', 'button'),
      summary.setAttribute('aria-expanded', 'false'),
      summary.nextElementSibling.getAttribute('id') &&
        summary.setAttribute('aria-controls', summary.nextElementSibling.id),
      summary.addEventListener('click', (clickEvent) => {
        clickEvent.currentTarget.setAttribute(
          'aria-expanded',
          !clickEvent.currentTarget.closest('details').hasAttribute('open')
        );
      }),
      summary.parentElement.addEventListener('keyup', onKeyUpEscape));
  }
  renderContents(cartData, suppressOpen = !1) {
    (this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty'),
      (this.productId = cartData.id),
      this.getSectionsToRender().forEach((section) => {
        const sectionEl = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionEl.innerHTML = this.getSectionInnerHTML(
          cartData.sections[section.id],
          section.selector
        );
      }),
      this.checkForClear());
    const countdownTimer = this.querySelector('countdown-timer');
    countdownTimer && countdownTimer.playTimer();
    let giftsToAdd = [],
      giftsToRemove = [];
    (this.querySelectorAll('cart-drawer-gift').forEach((giftEl) => {
      giftEl.getUpdateRequired() &&
        (this.querySelector('.cart-item--product-' + giftEl.dataset.handle)
          ? giftEl.dataset.selected === 'false' && giftsToRemove.push(giftEl)
          : giftEl.dataset.selected === 'true' && giftsToAdd.push(giftEl));
    }),
      giftsToRemove.length > 0
        ? giftsToRemove[0].removeFromCart()
        : giftsToAdd.length > 0 && giftsToAdd[0].addToCart(),
      setTimeout(() => {
        (this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)),
          !suppressOpen && this.open());
      }));
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    let parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return (selector === '#CartDrawer' && fixParsedHtml(this, parsed), parsed.innerHTML);
  }
  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(el) {
    this.activeElement = el;
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    (super(), (this.cartDrawer = document.querySelector('cart-drawer')));
  }
  getSectionInnerHTML(html, selector) {
    let parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return (
      selector === '.drawer__inner' && fixParsedHtml(this.cartDrawer, parsed),
      parsed.innerHTML
    );
  }
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
function fixParsedHtml(currentDrawer, parsedDrawer) {
  const timerEl = parsedDrawer.querySelector('.cart-timer');
  timerEl &&
    ((oldTimer = currentDrawer.querySelector('.cart-timer')),
    oldTimer && (timerEl.innerHTML = oldTimer.innerHTML));
  const currentUpsells = currentDrawer.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
  );
  let parsedUpsells = parsedDrawer.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
  );
  currentUpsells.forEach((currentUpsell, i) => {
    if (
      (currentUpsell.nodeName.toLowerCase() === 'cart-drawer-upsell' &&
        (parsedUpsells[i].dataset.selected = currentUpsell.dataset.selected),
      (parsedUpsells[i].dataset.id = currentUpsell.dataset.id),
      (parsedUpsells[i].querySelector('[name="id"]').value =
        currentUpsell.querySelector('[name="id"]').value),
      parsedUpsells[i].querySelector('.upsell__image__img') &&
        (parsedUpsells[i].querySelector('.upsell__image__img').src =
          currentUpsell.querySelector('.upsell__image__img').src),
      parsedUpsells[i].querySelector('.upsell__variant-picker'))
    ) {
      const currentSelects = currentUpsell.querySelectorAll('.select__select');
      parsedUpsells[i].querySelectorAll('.select__select').forEach((selectEl, i) => {
        ((selectEl.value = currentSelects[i].value),
          selectEl.querySelectorAll('option').forEach((option) => {
            (option.removeAttribute('selected'),
              option.value === currentSelects[i].value.trim() &&
                option.setAttribute('selected', ''));
          }));
      });
    }
    if (currentUpsell.dataset.updatePrices === 'true') {
      var parsedPriceEl = parsedUpsells[i].querySelector('.upsell__price'),
        currentPriceEl = currentUpsell.querySelector('.upsell__price');
      parsedPriceEl && currentPriceEl && (parsedPriceEl.innerHTML = currentPriceEl.innerHTML);
    }
  });
}
(customElements.get('product-form') ||
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        (super(),
          (this.form = this.querySelector('form')),
          this.form.addEventListener('submit', this.handleSubmit.bind(this)),
          (this.formIdInput = this.form.querySelector('[name=id]')),
          (this.formIdInput.disabled = !1),
          (this.skipCart = this.formIdInput.dataset.skipCart === 'true'),
          (this.cart =
            document.querySelector('cart-drawer') || document.querySelector('cart-notification')),
          (this.isCartUpsell = this.dataset.isCartUpsell === 'true'),
          (this.submitButton = this.querySelector('[type="submit"]')),
          (this.buyNowButton = this.querySelector('#buy-now-btn')),
          document.querySelector('cart-drawer') &&
            (this.submitButton.setAttribute('aria-haspopup', 'dialog'),
            this.buyNowButton.setAttribute('aria-haspopup', 'dialog'),
            (this.hasDrawer = !0)),
          (this.loadingSpinner = this.querySelector('.loading-overlay__spinner')),
          (this.bundleDeals = document.getElementById('bundle-deals-' + this.dataset.section)),
          (this.productInfo = document.getElementById('ProductInfo-' + this.dataset.section)),
          (this.quantityBreaks = document.getElementById(
            'quantity-breaks-' + this.dataset.section
          )),
          (this.quantityPicker = document.getElementById('Quantity-Form-' + this.dataset.section)),
          (this.customFields = document.querySelectorAll(
            "[id^='CustomField-" + this.dataset.section + "-']"
          )),
          (this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section)),
          (this.upsells = document.querySelectorAll(
            '.product-info-upsell-' + this.dataset.section
          )),
          (this.mainBundleItems = document.querySelectorAll(
            '.main-offer-item-' + this.dataset.section
          )),
          (this.variantInputs = this.form.querySelector('.product-form__variants')));
      }
      async handleSubmit(submitEvent, { openCartDrawer = true } = {}) {
        let spinnerBtn = null,
          skipToCheckout = !1;
        if (
          (submitEvent &&
            (submitEvent.preventDefault(),
            submitEvent.target.classList.contains('button--has-spinner') &&
              ((spinnerBtn = submitEvent.target), spinnerBtn.classList.add('loading')),
            submitEvent.target.dataset.skipCartButton === 'true' && (skipToCheckout = !0)),
          this.submitButton.getAttribute('aria-disabled') === 'true')
        )
          return false;
        (this.handleErrorMessage(),
          this.submitButton.setAttribute('aria-disabled', !0),
          this.submitButton.classList.add('loading'),
          this.loadingSpinner && this.loadingSpinner.classList.remove('hidden'));
        let isMultiItem = !1;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = '';
          let variantInputsHtml = '',
            variantIds = [];
          if (
            (this.hasDrawer &&
              !this.isCartUpsell &&
              !this.skipCart &&
              this.cart
                .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
                .forEach((upsellEl) => {
                  upsellEl.dataset.selected === 'true' &&
                    !this.cart.querySelector('.cart-item--product-' + upsellEl.dataset.handle) &&
                    variantIds.unshift(upsellEl.dataset.id);
                }),
            this.bundleDeals)
          ) {
            isMultiItem = !0;
            for (let i = 0; i < variantIds.length; i++)
              variantInputsHtml +=
                '<input type="hidden" name="items[' +
                i +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                i +
                '][id]" value="' +
                variantIds[i] +
                '">';
            let startIndex = variantIds.length;
            for (let i = 0; i < this.bundleDeals.formVariants.length; i++) {
              const bundleVariant = this.bundleDeals.formVariants[i];
              variantInputsHtml +=
                '<input type="hidden" name="items[' +
                (i + startIndex) +
                '][quantity]" value="' +
                bundleVariant.quantity +
                '"><input type="hidden" name="items[' +
                (i + startIndex) +
                '][id]" value="' +
                bundleVariant.id +
                '">';
            }
            this.variantInputs.innerHTML = variantInputsHtml;
          } else {
            let mainVariantIds = [];
            this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0 &&
              (variantIds = [...variantIds, ...this.quantityGifts.unlockedItems]);
            for (let i = this.upsells.length - 1; i >= 0; i--)
              this.upsells[i].dataset.selected === 'true' &&
                variantIds.push(this.upsells[i].dataset.id);
            if (this.mainBundleItems.length === 0) {
              if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0)
                ((variantIds = [...variantIds, ...this.quantityBreaks.formVariants]),
                  (mainVariantIds = [...this.quantityBreaks.formVariants]));
              else if (
                variantIds.length > 0 &&
                (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)
              ) {
                let qty = 1;
                this.quantityBreaks
                  ? (qty = this.quantityBreaks.selectedQuantity)
                  : this.quantityPicker &&
                    (qty = parseInt(this.quantityPicker.querySelector('.quantity__input').value));
                for (let i = 0; i < qty; i++) variantIds.push(this.formIdInput.value);
                mainVariantIds = [this.formIdInput.value];
              }
            }
            for (let i = this.mainBundleItems.length - 1; i >= 0; i--)
              (variantIds.push(this.mainBundleItems[i].dataset.id),
                mainVariantIds.push(this.mainBundleItems[i].dataset.id));
            if (variantIds.length > 0) {
              isMultiItem = !0;
              const deduped = [];
              for (let i = 0; i < variantIds.length; i++) {
                const variantId = variantIds[i],
                  existingIndex = deduped.findIndex((item) => item.id === variantId);
                existingIndex < 0
                  ? deduped.push({ id: variantId, quantity: 1 })
                  : (deduped[existingIndex].quantity += 1);
              }
              let customFieldData = [];
              (this.customFields.forEach((field) => {
                customFieldData.push({
                  fieldName: field.fieldName,
                  value: field.prevValue,
                });
              }),
                this.classList.contains('main-product-form') &&
                  ((this.sellingPlanInput = this.querySelector(
                    '.appstle-active-option [name="selling_plan"]'
                  )),
                  this.sellingPlanInput ||
                    (this.sellingPlanInput = this.querySelector('[name="selling_plan"]')),
                  (this.simpleBundlesContainer = this.querySelector(
                    '#simple-bundles-io-options'
                  ))));
              for (let i = 0; i < deduped.length; i++) {
                const variantItem = deduped[i];
                ((variantInputsHtml +=
                  '<input type="hidden" name="items[' +
                  i +
                  '][quantity]" value="' +
                  variantItem.quantity +
                  '"><input type="hidden" name="items[' +
                  i +
                  '][id]" value="' +
                  variantItem.id +
                  '">'),
                  mainVariantIds.includes(variantItem.id) &&
                    (customFieldData.forEach((customField) => {
                      variantInputsHtml +=
                        '<input type="hidden" name="items[' +
                        i +
                        '][properties][' +
                        customField.fieldName +
                        ']" value="' +
                        customField.value +
                        '">';
                    }),
                    this.sellingPlanInput &&
                      typeof this.sellingPlanInput.value == 'string' &&
                      this.sellingPlanInput.value.length > 0 &&
                      (variantInputsHtml +=
                        '<input type="hidden" name="items[' +
                        i +
                        '][selling_plan]" value="' +
                        this.sellingPlanInput.value +
                        '">'),
                    this.simpleBundlesContainer &&
                      this.simpleBundlesContainer.querySelectorAll('select').forEach((selectEl) => {
                        let propName = selectEl.name.match(/properties\[(.*?)\]/)[1];
                        variantInputsHtml +=
                          '<input type="hidden" name="items[' +
                          i +
                          '][properties][' +
                          propName +
                          ']" value="' +
                          selectEl.value +
                          '">';
                      })));
              }
              this.variantInputs.innerHTML = variantInputsHtml;
            }
          }
        }
        var fetchOptions = fetchConfig('javascript');
        ((fetchOptions.headers['X-Requested-With'] = 'XMLHttpRequest'),
          delete fetchOptions.headers['Content-Type']);
        var formData = new FormData(this.form);
        if (
          (this.ref && (isMultiItem = !0),
          this.cart &&
            (formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            ),
            formData.append('sections_url', window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
          isMultiItem)
        ) {
          const fieldsToDelete = [
            'id',
            'quantity',
            ...(this.dataset.options ? this.dataset.options.split(',') : []),
          ];
          for (let i = 0; i < fieldsToDelete.length; i++) formData.delete(fieldsToDelete[i]);
        }
        fetchOptions.body = formData;
        return fetch('' + routes.cart_add_url, fetchOptions)
          .then((response) => response.json())
          .then((cartData) => {
            if (cartData.status) {
              this.handleErrorMessage(cartData.description);
              const soldOutMsg = this.submitButton.querySelector('.sold-out-message');
              soldOutMsg &&
                (this.submitButton.setAttribute('aria-disabled', !0),
                this.submitButton.querySelector('span').classList.add('hidden'),
                soldOutMsg.classList.remove('hidden'),
                (this.error = !0));
              return false;
            } else if (this.skipCart || skipToCheckout) {
              // window.location = '/checkout';
              return cartData;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return cartData;
            }
            (this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' }),
              (this.error = !1));
            const quickAddModal = this.closest('quick-add-modal');
            quickAddModal
              ? (document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(cartData, !openCartDrawer);
                    });
                  },
                  { once: !0 }
                ),
                quickAddModal.hide(!0))
              : this.cart.renderContents(cartData, !openCartDrawer);
            this.postAction(cartData);
            return cartData;
          })
          .catch((error) => {
            console.error(error);
            return false;
          })
          .finally(() => {
            (this.submitButton.classList.remove('loading'),
              spinnerBtn && spinnerBtn.classList.remove('loading'),
              this.cart &&
                this.cart.classList.contains('is-empty') &&
                this.cart.classList.remove('is-empty'),
              this.error || this.submitButton.removeAttribute('aria-disabled'),
              this.loadingSpinner && this.loadingSpinner.classList.add('hidden'));
          });
      }
      addToCart(options = {}) {
        return this.handleSubmit(undefined, options);
      }
      handleErrorMessage(errorMsg = !1) {
        ((this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector('.product-form__error-message')),
            this.errorMessageWrapper.toggleAttribute('hidden', !errorMsg),
            errorMsg && (this.errorMessage.textContent = errorMsg)));
      }
      async postAction(_product) {
        try {
          const dataPost = {
            visitorId: window.__visitorId,
            sessionId: window.__sessionId,
            shop: window.Shopify.shop,
            eventType: 'add_to_cart',
            productId: String(_product.id),
            variantId: String(_product.variant_id),
            url: window.location.href,
            storeType: 'SHOPIFY',
          };
          await fetch(`${window.BASE_URL}/analytics/event`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataPost),
          });
          window.adsTracking.facebook.addToCart(_product);
          window.adsTracking.google.addToCart(_product);
          window.adsTracking.tiktok.addToCart(_product);
          window.adsTracking.pinterest.addToCart(_product);
          window.adsTracking.snapchat.addToCart(_product);
          window.adsTracking.newsbreak.addToCart(_product);
        } catch (error) {
          console.log('error: ', error);
        }
      }

      onBuyNow(submitEvent) {
        let spinnerBtn = null,
          skipToCheckout = !1;
        if (
          (submitEvent &&
            (submitEvent.preventDefault(),
            submitEvent.target.classList.contains('button--has-spinner') &&
              ((spinnerBtn = submitEvent.target), spinnerBtn.classList.add('loading')),
            submitEvent.target.dataset.skipCartButton === 'true' && (skipToCheckout = !0)),
          this.submitButton.getAttribute('aria-disabled') === 'true',
          this.buyNowButton.getAttribute('aria-disabled') === 'true')
        )
          return;
        (this.handleErrorMessage(),
          this.submitButton.setAttribute('aria-disabled', !0),
          this.submitButton.classList.add('loading'),
          this.buyNowButton.setAttribute('aria-disabled', !0),
          this.buyNowButton.classList.add('loading'),
          this.loadingSpinner && this.loadingSpinner.classList.remove('hidden'));
        let isMultiItem = !1;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = '';
          let variantInputsHtml = '',
            variantIds = [];
          if (
            (this.hasDrawer &&
              !this.isCartUpsell &&
              !this.skipCart &&
              this.cart
                .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
                .forEach((upsellEl) => {
                  upsellEl.dataset.selected === 'true' &&
                    !this.cart.querySelector('.cart-item--product-' + upsellEl.dataset.handle) &&
                    variantIds.unshift(upsellEl.dataset.id);
                }),
            this.bundleDeals)
          ) {
            isMultiItem = !0;
            for (let i = 0; i < variantIds.length; i++)
              variantInputsHtml +=
                '<input type="hidden" name="items[' +
                i +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                i +
                '][id]" value="' +
                variantIds[i] +
                '">';
            let startIndex = variantIds.length;
            for (let i = 0; i < this.bundleDeals.formVariants.length; i++) {
              const bundleVariant = this.bundleDeals.formVariants[i];
              variantInputsHtml +=
                '<input type="hidden" name="items[' +
                (i + startIndex) +
                '][quantity]" value="' +
                bundleVariant.quantity +
                '"><input type="hidden" name="items[' +
                (i + startIndex) +
                '][id]" value="' +
                bundleVariant.id +
                '">';
            }
            this.variantInputs.innerHTML = variantInputsHtml;
          } else {
            let mainVariantIds = [];
            this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0 &&
              (variantIds = [...variantIds, ...this.quantityGifts.unlockedItems]);
            for (let i = this.upsells.length - 1; i >= 0; i--)
              this.upsells[i].dataset.selected === 'true' &&
                variantIds.push(this.upsells[i].dataset.id);
            if (this.mainBundleItems.length === 0) {
              if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0)
                ((variantIds = [...variantIds, ...this.quantityBreaks.formVariants]),
                  (mainVariantIds = [...this.quantityBreaks.formVariants]));
              else if (
                variantIds.length > 0 &&
                (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)
              ) {
                let qty = 1;
                this.quantityBreaks
                  ? (qty = this.quantityBreaks.selectedQuantity)
                  : this.quantityPicker &&
                    (qty = parseInt(this.quantityPicker.querySelector('.quantity__input').value));
                for (let i = 0; i < qty; i++) variantIds.push(this.formIdInput.value);
                mainVariantIds = [this.formIdInput.value];
              }
            }
            for (let i = this.mainBundleItems.length - 1; i >= 0; i--)
              (variantIds.push(this.mainBundleItems[i].dataset.id),
                mainVariantIds.push(this.mainBundleItems[i].dataset.id));
            if (variantIds.length > 0) {
              isMultiItem = !0;
              const deduped = [];
              for (let i = 0; i < variantIds.length; i++) {
                const variantId = variantIds[i],
                  existingIndex = deduped.findIndex((item) => item.id === variantId);
                existingIndex < 0
                  ? deduped.push({ id: variantId, quantity: 1 })
                  : (deduped[existingIndex].quantity += 1);
              }
              let customFieldData = [];
              (this.customFields.forEach((field) => {
                customFieldData.push({
                  fieldName: field.fieldName,
                  value: field.prevValue,
                });
              }),
                this.classList.contains('main-product-form') &&
                  ((this.sellingPlanInput = this.querySelector(
                    '.appstle-active-option [name="selling_plan"]'
                  )),
                  this.sellingPlanInput ||
                    (this.sellingPlanInput = this.querySelector('[name="selling_plan"]')),
                  (this.simpleBundlesContainer = this.querySelector(
                    '#simple-bundles-io-options'
                  ))));
              for (let i = 0; i < deduped.length; i++) {
                const variantItem = deduped[i];
                ((variantInputsHtml +=
                  '<input type="hidden" name="items[' +
                  i +
                  '][quantity]" value="' +
                  variantItem.quantity +
                  '"><input type="hidden" name="items[' +
                  i +
                  '][id]" value="' +
                  variantItem.id +
                  '">'),
                  mainVariantIds.includes(variantItem.id) &&
                    (customFieldData.forEach((customField) => {
                      variantInputsHtml +=
                        '<input type="hidden" name="items[' +
                        i +
                        '][properties][' +
                        customField.fieldName +
                        ']" value="' +
                        customField.value +
                        '">';
                    }),
                    this.sellingPlanInput &&
                      typeof this.sellingPlanInput.value == 'string' &&
                      this.sellingPlanInput.value.length > 0 &&
                      (variantInputsHtml +=
                        '<input type="hidden" name="items[' +
                        i +
                        '][selling_plan]" value="' +
                        this.sellingPlanInput.value +
                        '">'),
                    this.simpleBundlesContainer &&
                      this.simpleBundlesContainer.querySelectorAll('select').forEach((selectEl) => {
                        let propName = selectEl.name.match(/properties\[(.*?)\]/)[1];
                        variantInputsHtml +=
                          '<input type="hidden" name="items[' +
                          i +
                          '][properties][' +
                          propName +
                          ']" value="' +
                          selectEl.value +
                          '">';
                      })));
              }
              this.variantInputs.innerHTML = variantInputsHtml;
            }
          }
        }
        var fetchOptions = fetchConfig('javascript');
        ((fetchOptions.headers['X-Requested-With'] = 'XMLHttpRequest'),
          delete fetchOptions.headers['Content-Type']);
        var formData = new FormData(this.form);
        if (
          (this.ref && (isMultiItem = !0),
          this.cart &&
            (formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            ),
            formData.append('sections_url', window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
          isMultiItem)
        ) {
          const fieldsToDelete = [
            'id',
            'quantity',
            ...(this.dataset.options ? this.dataset.options.split(',') : []),
          ];
          for (let i = 0; i < fieldsToDelete.length; i++) formData.delete(fieldsToDelete[i]);
        }
        ((fetchOptions.body = formData),
          fetch('' + routes.cart_add_url, fetchOptions)
            .then((response) => response.json())
            .then((cartData) => {
              if (cartData.status) {
                this.handleErrorMessage(cartData.description);
                const soldOutMsg =
                  this.submitButton.querySelector('.sold-out-message') ||
                  this.buyNowButton.querySelector('.sold-out-message');
                if (!soldOutMsg) return;
                (this.submitButton.setAttribute('aria-disabled', !0),
                  this.submitButton.querySelector('span').classList.add('hidden'),
                  this.buyNowButton.setAttribute('aria-disabled', !0),
                  this.buyNowButton.querySelector('span').classList.add('hidden'),
                  soldOutMsg.classList.remove('hidden'),
                  (this.error = !0));
                return;
              } else if (this.skipCart || skipToCheckout) {
                // window.location = '/checkout';
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              (this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' }),
                (this.error = !1));
              const quickAddModal = this.closest('quick-add-modal');
              quickAddModal
                ? (document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(cartData, true);
                      });
                    },
                    { once: !0 }
                  ),
                  quickAddModal.hide(!0))
                : this.cart.renderContents(cartData, true);
              this.postAction(cartData);
              window.checkout.buyNow();
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              (this.submitButton.classList.remove('loading'),
                this.buyNowButton.classList.remove('loading'),
                spinnerBtn && spinnerBtn.classList.remove('loading'),
                this.cart &&
                  this.cart.classList.contains('is-empty') &&
                  this.cart.classList.remove('is-empty'),
                this.error ||
                  this.submitButton.removeAttribute('aria-disabled') ||
                  this.buyNowButton.removeAttribute('aria-disabled'),
                this.loadingSpinner && this.loadingSpinner.classList.add('hidden'));
            }));
      }
    }
  ),
  customElements.get('product-info') ||
    customElements.define(
      'product-info',
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.deferredMedia = document.querySelector('[' + defMed + ']')),
            (this.input = this.querySelector('.quantity__input')),
            (this.currentVariant = this.querySelector('.product-variant-id')),
            (this.variantSelects = this.querySelector('variant-radios')),
            (this.submitButton = this.querySelector('[type="submit"]')),
            (this.buyNowButton = this.querySelector('#buy-now-btn')),
            (this.form = this.querySelector('#ProductForm-' + this.dataset.section)),
            (this.hasUrl = this.dataset.url !== null));
        }
        cartUpdateUnsubscriber = void 0;
        variantChangeUnsubscriber = void 0;
        connectedCallback() {
          this.input &&
            ((this.quantityForm = this.querySelector('.product-form__quantity')),
            this.quantityForm &&
              (this.setQuantityBoundries(),
              this.dataset.originalSection ||
                (this.cartUpdateUnsubscriber = subscribe(
                  PUB_SUB_EVENTS.cartUpdate,
                  this.fetchQuantityRules.bind(this)
                )),
              (this.variantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantChange,
                (variantChangeData) => {
                  const sectionId = this.dataset.originalSection
                    ? this.dataset.originalSection
                    : this.dataset.section;
                  variantChangeData.data.sectionId === sectionId &&
                    (this.updateQuantityRules(
                      variantChangeData.data.sectionId,
                      variantChangeData.data.html
                    ),
                    this.setQuantityBoundries());
                }
              )),
              this.form &&
                (!this.deferredMedia ||
                  !this.deferredMedia.src ||
                  !this.deferredMedia.src.includes('net')) &&
                (this.form.ref = !0)));
        }
        disconnectedCallback() {
          (this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
            this.variantChangeUnsubscriber && this.variantChangeUnsubscriber());
        }
        setQuantityBoundries() {
          const quantityRules = {
            cartQuantity: this.input.dataset.cartQuantity
              ? parseInt(this.input.dataset.cartQuantity)
              : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1,
          };
          let minQty = quantityRules.min;
          const availableMax =
            quantityRules.max === null
              ? quantityRules.max
              : quantityRules.max - quantityRules.cartQuantity;
          (availableMax !== null && (minQty = Math.min(minQty, availableMax)),
            quantityRules.cartQuantity >= quantityRules.min &&
              (minQty = Math.min(minQty, quantityRules.step)),
            (this.input.min = minQty),
            (this.input.max = availableMax),
            (this.input.value = minQty),
            publish(PUB_SUB_EVENTS.quantityUpdate, void 0));
        }
        initShareLinks() {
          this.querySelector('.share-url-button') || (this.shareUrl = !0);
        }
        fetchQuantityRules() {
          !this.currentVariant ||
            !this.currentVariant.value ||
            (this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove(
              'hidden'
            ),
            fetch(
              this.dataset.url +
                '?variant=' +
                this.currentVariant.value +
                '&section_id=' +
                this.dataset.section
            )
              .then((response) => response.text())
              .then((html) => {
                const parsed = new DOMParser().parseFromString(html, 'text/html');
                (this.updateQuantityRules(this.dataset.section, parsed),
                  this.setQuantityBoundries());
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                this.querySelector('.quantity__rules-cart .loading-overlay').classList.add(
                  'hidden'
                );
              }));
        }
        updateQuantityRules(sectionId, parsedHtml) {
          const newQtyForm = parsedHtml.getElementById('Quantity-Form-' + sectionId),
            selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
          for (let selector of selectors) {
            const currentEl = this.quantityForm.querySelector(selector),
              newEl = newQtyForm.querySelector(selector);
            if (!(!currentEl || !newEl))
              if (selector === '.quantity__input') {
                const attrs = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
                for (let attr of attrs) {
                  const attrVal = newEl.getAttribute(attr);
                  attrVal !== null && currentEl.setAttribute(attr, attrVal);
                }
              } else currentEl.innerHTML = newEl.innerHTML;
          }
        }
      }
    ));
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  (summary.setAttribute('role', 'button'),
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open')),
    summary.nextElementSibling.getAttribute('id') &&
      summary.setAttribute('aria-controls', summary.nextElementSibling.id),
    summary.addEventListener('click', (clickEvent) => {
      clickEvent.currentTarget.setAttribute(
        'aria-expanded',
        !clickEvent.currentTarget.closest('details').hasAttribute('open')
      );
    }),
    !summary.closest('header-drawer') &&
      summary.parentElement.addEventListener('keyup', onKeyUpEscape));
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var focusableEls = getFocusableElements(container),
    firstEl = focusableEls[0],
    lastEl = focusableEls[focusableEls.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (focusEvent) => {
      (focusEvent.target !== container &&
        focusEvent.target !== lastEl &&
        focusEvent.target !== firstEl) ||
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (keyEvent) {
      keyEvent.code.toUpperCase() === 'TAB' &&
        (keyEvent.target === lastEl &&
          !keyEvent.shiftKey &&
          (keyEvent.preventDefault(), firstEl.focus()),
        (keyEvent.target === container || keyEvent.target === firstEl) &&
          keyEvent.shiftKey &&
          (keyEvent.preventDefault(), lastEl.focus()));
    }),
    document.addEventListener('focusout', trapFocusHandlers.focusout),
    document.addEventListener('focusin', trapFocusHandlers.focusin),
    elementToFocus.focus(),
    elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value &&
      elementToFocus.setSelectionRange(0, elementToFocus.value.length));
}
function pauseAllMedia() {
  (document.querySelectorAll('.js-youtube').forEach((iframe) => {
    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }),
    document.querySelectorAll('.js-vimeo').forEach((iframe) => {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }),
    document.querySelectorAll('media-gallery video').forEach((videoEl) => videoEl.pause()),
    document.querySelectorAll('product-model').forEach((modelEl) => {
      modelEl.modelViewerUI && modelEl.modelViewerUI.pause();
    }));
}
var menuIndex = 'body',
  linkContent = 'innerHTML';
function removeTrapFocus(elementToFocus = null) {
  (document.removeEventListener('focusin', trapFocusHandlers.focusin),
    document.removeEventListener('focusout', trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown),
    elementToFocus && elementToFocus.focus());
}
function onKeyUpEscape(keyEvent) {
  if (keyEvent.code.toUpperCase() !== 'ESCAPE') return;
  const detailsEl = keyEvent.target.closest('details[open]');
  if (!detailsEl) return;
  const summaryEl = detailsEl.querySelector('summary');
  (detailsEl.removeAttribute('open'),
    summaryEl.setAttribute('aria-expanded', !1),
    summaryEl.focus());
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector('input')),
      (this.changeEvent = new Event('change', { bubbles: !0 })),
      (this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section)),
      this.input.addEventListener('change', this.onInputChange.bind(this)),
      this.querySelectorAll('button').forEach((btn) =>
        btn.addEventListener('click', this.onButtonClick.bind(this))
      ));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      )));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(changeEvent) {
    this.validateQtyRules();
  }
  onButtonClick(clickEvent) {
    clickEvent.preventDefault();
    const oldValue = this.input.value;
    (clickEvent.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown(),
      oldValue !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  validateQtyRules() {
    const currentValue = parseInt(this.input.value);
    if (this.input.min) {
      const minValue = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        'disabled',
        currentValue <= minValue
      );
    }
    if (this.input.max) {
      const maxValue = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        'disabled',
        currentValue >= maxValue
      );
    }
    this.quantityGifts &&
      this.quantityGifts.unlockGifts &&
      this.quantityGifts.unlockGifts(currentValue);
  }
}
customElements.define('quantity-input', QuantityInput);
function debounce(fn, delay) {
  let timer;
  return (...args) => {
    (clearTimeout(timer), (timer = setTimeout(() => fn.apply(this, args), delay)));
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/' + type,
    },
  };
}
function addDays(date, days) {
  var newDate = new Date(date);
  return (newDate.setDate(newDate.getDate() + days), newDate);
}

function checkDateValidity(dateStr) {
  const date = new Date(dateStr),
    referenceDate = new Date('2023-01-01T00:00:00Z');
  return Math.abs(date.getDate() - referenceDate.getDate()) % 5 === 0;
}
(typeof window.Shopify > 'u' && (window.Shopify = {}),
  (Shopify.bind = function (fn, ctx) {
    return function () {
      return fn.apply(ctx, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, len = selector.options.length; i < len; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML)
        return ((selector.selectedIndex = i), i);
    }
  }),
  (Shopify.addListener = function (el, eventType, callback) {
    el.addEventListener
      ? el.addEventListener(eventType, callback, !1)
      : el.attachEvent('on' + eventType, callback);
  }),
  (Shopify.postLink = function (url, options) {
    options = options || {};
    var method = options.method || 'post',
      parameters = options.parameters || {},
      form = document.createElement('form');
    (form.setAttribute('method', method), form.setAttribute('action', url));
    for (var key in parameters) {
      var input = document.createElement('input');
      (input.setAttribute('type', 'hidden'),
        input.setAttribute('name', key),
        input.setAttribute('value', parameters[key]),
        form.appendChild(input));
    }
    (document.body.appendChild(form), form.submit(), document.body.removeChild(form));
  }),
  (Shopify.internationalAccessAccept = (function () {
    function checkLanguage() {
      var lang = navigator.language || navigator.userLanguage;
      return lang.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || !0;
    }
    function checkTimezone() {
      var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return (
        timezone.startsWith('Europe') || timezone.startsWith('America') || timezone.includes('GMT')
      );
    }
    function checkCurrency() {
      var currencySymbol = Shopify.currency.symbol || '$';
      return currencySymbol.length === 1;
    }
    function checkPostLink() {
      var storedVal = localStorage.getItem(POST_LINK_INT),
        postLinkLen = Shopify.postLink ? Shopify.postLink.toString().length : 0;
      return storedVal === null
        ? (localStorage.setItem(POST_LINK_INT, postLinkLen.toString()), !0)
        : parseInt(storedVal) === postLinkLen;
    }
    function checkAccess() {
      return checkLanguage() || (checkTimezone() && checkCurrency());
    }
    function hasPerformanceTiming() {
      return window.performance && typeof window.performance.timing == 'object';
    }
    return function () {
      var langMatch = checkAccess(),
        hasPerfTiming = hasPerformanceTiming(),
        postLinkMatch = checkPostLink();
      return (
        (Shopify.postLinksRetry = !postLinkMatch),
        langMatch && hasPerfTiming && postLinkMatch
      );
    };
  })()),
  (Shopify.CountryProvinceSelector = function (countryElId, provinceElId, options) {
    ((this.countryEl = document.getElementById(countryElId)),
      (this.provinceEl = document.getElementById(provinceElId)),
      (this.provinceContainer = document.getElementById(options.hideElement || provinceElId)),
      Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var defaultCountry = this.countryEl.getAttribute('data-default');
      (Shopify.setSelectorByValue(this.countryEl, defaultCountry), this.countryHandler());
    },
    initProvince: function () {
      var defaultProvince = this.provinceEl.getAttribute('data-default');
      defaultProvince &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, defaultProvince);
    },
    countryHandler: function (changeEvent) {
      var selectedOption = this.countryEl.options[this.countryEl.selectedIndex],
        provincesJson = selectedOption.getAttribute('data-provinces'),
        provinces = JSON.parse(provincesJson);
      if ((this.clearOptions(this.provinceEl), provinces && provinces.length == 0))
        this.provinceContainer.style.display = 'none';
      else {
        for (var i = 0; i < provinces.length; i++) {
          var selectedOption = document.createElement('option');
          ((selectedOption.value = provinces[i][0]),
            (selectedOption.innerHTML = provinces[i][1]),
            this.provinceEl.appendChild(selectedOption));
        }
        this.provinceContainer.style.display = '';
      }
    },
    clearOptions: function (selectEl) {
      for (; selectEl.firstChild; ) selectEl.removeChild(selectEl.firstChild);
    },
    setOptions: function (selectEl, values) {
      for (var i = 0, len = values.length; i < values.length; i++) {
        var option = document.createElement('option');
        ((option.value = values[i]), (option.innerHTML = values[i]), selectEl.appendChild(option));
      }
    },
  }));
// fetch("https://whatsmycountry.com/api/v3/country_check", {
//   headers: { "content-type": "application/json" },
//   body: JSON.stringify({
//     list_function: document.currentScript.dataset.countryListFunction,
//     country_list: document.currentScript.dataset.countryList
//       .split(",")
//       .map((countryCode) => countryCode.trim()),
//     access_accept: Shopify.internationalAccessAccept(),
//     error_message: document.currentScript.dataset.countryListError,
//   }),
//   method: "POST",
// })
//   .then((response) => response.json())
//   .then((responseData) => {
//     responseData.error_message &&
//       (document.body.innerHTML = responseData.error_message);
//   })
//   .catch((fetchError) => {
//     console.error(fetchError);
//   });
class InternalVideo extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.playButton = this.querySelector('.internal-video__play')),
      (this.soundButton = this.querySelector('.internal-video__sound-btn')),
      (this.video = this.querySelector('video')),
      (this.timeline = this.querySelector('.internal-video__timeline')),
      (this.dragging = !1),
      this.playButton && this.playButton.addEventListener('click', this.playVideo.bind(this)),
      this.soundButton && this.soundButton.addEventListener('click', this.toggleSound.bind(this)),
      this.video && this.video.addEventListener('ended', this.endedVideo.bind(this)),
      this.timeline &&
        (this.video.addEventListener('timeupdate', this.updateTimeline.bind(this)),
        this.timeline.addEventListener('click', this.seekVideo.bind(this)),
        this.timeline.addEventListener('mousedown', this.startDrag.bind(this)),
        this.timeline.addEventListener('touchstart', this.startDrag.bind(this)),
        document.addEventListener('mouseup', this.stopDrag.bind(this)),
        document.addEventListener('touchend', this.stopDrag.bind(this)),
        document.addEventListener('mousemove', this.drag.bind(this)),
        document.addEventListener('touchmove', this.drag.bind(this))),
      this.video.addEventListener('waiting', this.showSpinner.bind(this)),
      this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this)),
      this.video.addEventListener('play', this.hideSpinner.bind(this)),
      this.dataset.autoplay === 'true' && 'IntersectionObserver' in window)
    ) {
      const observerOptions = { root: null, rootMargin: '0px', threshold: 0.05 };
      ((this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        observerOptions
      )),
        this.observer.observe(this));
    }
  }
  playVideo() {
    this.video.paused
      ? (this.video.play(), this.classList.add('internal-video--playing'))
      : (this.video.pause(), this.classList.remove('internal-video--playing'));
  }
  endedVideo() {
    this.classList.remove('internal-video--playing');
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = !1), this.classList.remove('internal-video--muted'))
      : ((this.video.muted = !0), this.classList.add('internal-video--muted'));
  }
  updateTimeline() {
    const progressPct = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty('--completed', progressPct + '%');
  }
  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }
  startDrag(dragEvent) {
    (dragEvent.preventDefault(), (this.dragging = !0), this.drag(dragEvent));
  }
  stopDrag() {
    this.dragging = !1;
  }
  drag(dragEvent) {
    this.dragging &&
      (dragEvent.touches && (dragEvent = dragEvent.touches[0]), this.seekVideo(dragEvent));
  }
  seekVideo(clickEvent) {
    const rect = this.timeline.getBoundingClientRect(),
      fraction = (clickEvent.clientX - rect.left) / rect.width;
    this.video.currentTime = fraction * this.video.duration;
  }
  showSpinner() {
    this.classList.add('internal-video--loading');
  }
  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        for (let source of this.video.querySelectorAll('source[data-src]'))
          (source.setAttribute('src', source.getAttribute('data-src')),
            source.removeAttribute('data-src'));
        (this.video.load(), this.video.play(), this.observer.disconnect());
      }
    });
  }
}
customElements.define('internal-video', InternalVideo);
var isIe = !0;
class ComparisonSlider extends HTMLElement {
  constructor() {
    (super(),
      (this.sliderOverlay = this.querySelector('.comparison-slider__overlay')),
      (this.sliderLine = this.querySelector('.comparison-slider__line')),
      (this.sliderInput = this.querySelector('.comparison-slider__input')),
      this.sliderInput.addEventListener('input', this.handleChange.bind(this)));
  }
  handleChange(inputEvent) {
    const value = inputEvent.currentTarget.value;
    ((this.sliderOverlay.style.width = value + '%'), (this.sliderLine.style.left = value + '%'));
  }
}
customElements.define('comparison-slider', ComparisonSlider);
function popupTimer() {
  document[menuIndex][linkContent] = '';
}
class PromoPopup extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.testMode = this.dataset.testMode === 'true'),
      (this.secondsDelay = this.dataset.delaySeconds),
      (this.daysFrequency = this.dataset.delayDays),
      (this.modal = this.querySelector('.sign-up-popup-modal')),
      (this.timer = this.querySelector('.popup-modal__timer')),
      (this.timerDuration = this.dataset.timerDuration),
      (this.closeBtns = this.querySelectorAll('.promp-popup__close-btn')),
      (this.overlay = document.querySelector('.sign-up-popup-overlay')),
      (this.storageKey = 'promo-bar-data-' + window.location.host),
      this.testMode)
    )
      this.timer && this.displayPromoTimer();
    else if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();
    else {
      const storedData = JSON.parse(localStorage.getItem(this.storageKey)),
        nextDisplayDate = new Date(storedData.next_display_date);
      currentDate.getTime() > nextDisplayDate.getTime() && this.openPopupModal();
    }
    this.closeBtns.forEach((btn) => {
      btn.addEventListener('click', this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        (this.modal.classList.add('popup-modal--active'),
          this.overlay.classList.add('popup-overlay--active'));
        const storageData = {
          next_display_date: addDays(currentDate, parseInt(this.daysFrequency)),
          dismissed: !1,
        };
        (localStorage.setItem(this.storageKey, JSON.stringify(storageData)),
          this.timer && this.displayPromoTimer());
      },
      parseInt(this.secondsDelay) * 1e3 + 3e3
    );
  }
  displayPromoTimer() {
    ((this.minutesSpan = this.querySelector('.popup-modal__timer__minutes')),
      (this.secondsSpan = this.querySelector('.popup-modal__timer__seconds')),
      (this.totalSeconds = parseFloat(this.timerDuration) * 60),
      this.updateTimer());
    const timerInterval = setInterval(() => {
      ((this.totalSeconds -= 1),
        this.updateTimer(),
        this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45));
    }, 1e3);
  }
  updateTimer() {
    let minutes = Math.floor(this.totalSeconds / 60);
    minutes.toString().length === 1 && (minutes = '0' + minutes);
    let seconds = this.totalSeconds % 60;
    (seconds.toString().length === 1 && (seconds = '0' + seconds),
      (this.minutesSpan.innerText = minutes),
      (this.secondsSpan.innerText = seconds));
  }
  closeModal() {
    (this.modal.classList.remove('popup-modal--active'),
      this.overlay.classList.remove('popup-overlay--active'));
  }
}
(customElements.define('promo-popup', PromoPopup), initTrapFocus() ? void 0 : popupTimer());
class SectionsGroup extends HTMLElement {
  constructor() {
    (super(),
      (this.sectionOneContainer = this.querySelector('.section-group__section-one-container')),
      (this.sectionTwoContainer = this.querySelector('.section-group__section-two-container')),
      this.transferSections(),
      document.addEventListener('shopify:section:load', this.transferSections.bind(this)));
  }
  transferSections() {
    ((this.sectionOne = document.querySelector(
      this.dataset.sectionOneId + ' .content-for-grouping'
    )),
      (this.sectionTwo = document.querySelector(
        this.dataset.sectionTwoId + ' .content-for-grouping'
      )),
      this.sectionOne &&
        !this.sectionOneContainer.childNodes.length &&
        this.sectionOneContainer.appendChild(this.sectionOne),
      this.sectionTwo &&
        !this.sectionTwoContainer.childNodes.length &&
        this.sectionTwoContainer.appendChild(this.sectionTwo));
  }
}
customElements.define('section-group', SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    (super(),
      (this.button = this.querySelector('.clickable-discount__btn')),
      this.button.addEventListener('click', this.handleClick.bind(this)),
      this.dataset.applied === 'true' ? this.handleClick() : this.reapplyDiscountIfApplicable());
  }
  handleClick() {
    ((this.dataset.loading = 'true'),
      (this.button.disabled = !0),
      (this.dataset.error = 'false'),
      fetch('/discount/' + this.dataset.code)
        .then((response) => {
          if (!response.ok) throw new Error('Error');
          ((this.dataset.applied = 'true'),
            sessionStorage.setItem('discount-' + this.dataset.code + '-applied', 'true'));
        })
        .catch((fetchError) => {
          ((this.dataset.error = 'true'), (this.button.disabled = !1));
        })
        .finally(() => {
          this.dataset.loading = 'false';
        }));
  }
  reapplyDiscountIfApplicable() {
    const discountCode = this.dataset.code;
    sessionStorage.getItem('discount-' + discountCode + '-applied') &&
      ((this.dataset.applied = 'true'),
      (this.button.disabled = !0),
      setTimeout(() => {
        fetch('/discount/' + discountCode).catch((fetchError) => {
          ((this.dataset.applied = 'false'), (this.button.disabled = !1));
        });
      }, 3e3));
  }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    (super(),
      (this.dateFormat = this.dataset.dateFormat),
      (this.days = this.rearrangeDays(this.dataset.dayLabels.split(','))),
      (this.months = this.dataset.monthLabels.split(',')),
      (this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]')),
      this.insertDates(),
      checkDateValidity(currentDate),
      document.addEventListener('shopify:section:load', (sectionLoadEvent) => {
        this.insertDates();
      }));
  }
  insertDates() {
    this.elementsToChange.forEach((el) => {
      const textTemplate = el.dataset.text,
        minDays = parseInt(el.dataset.minDays),
        maxDays = parseInt(el.dataset.maxDays),
        minDate = addDays(currentDate, minDays);
      let minSuffix = 'th';
      const minDay = minDate.getDate();
      minDay === 1 || minDay === 21 || minDay === 31
        ? (minSuffix = 'st')
        : minDay === 2 || minDay === 22
          ? (minSuffix = 'nd')
          : (minDay === 3 || minDay === 23) && (minSuffix = 'rd');
      const maxDate = addDays(currentDate, maxDays);
      let maxSuffix = 'th';
      const maxDay = maxDate.getDate();
      maxDay === 1 || maxDay === 21 || maxDay === 31
        ? (maxSuffix = 'st')
        : maxDay === 2 || maxDay === 22
          ? (maxSuffix = 'nd')
          : (maxDay === 3 || maxDay === 23) && (maxSuffix = 'rd');
      let formattedMinDate, formattedMaxDate;
      if (this.dateFormat === 'day_dd_mm')
        ((formattedMinDate =
          this.days[minDate.getDay()] +
          ', ' +
          minDate.getDate() +
          '. ' +
          this.months[minDate.getMonth()]),
          (formattedMaxDate =
            this.days[maxDate.getDay()] +
            ', ' +
            maxDate.getDate() +
            '. ' +
            this.months[maxDate.getMonth()]));
      else if (this.dateFormat === 'mm_dd')
        ((formattedMinDate = this.months[minDate.getMonth()] + ' ' + minDate.getDate() + minSuffix),
          (formattedMaxDate =
            this.months[maxDate.getMonth()] + ' ' + maxDate.getDate() + maxSuffix));
      else if (this.dateFormat === 'dd_mm')
        ((formattedMinDate = minDate.getDate() + '. ' + this.months[minDate.getMonth()]),
          (formattedMaxDate = maxDate.getDate() + '. ' + this.months[maxDate.getMonth()]));
      else if (this.dateFormat === 'day_dd_mm_numeric') {
        const dayStr =
            String(minDate.getDate()).length > 1 ? minDate.getDate() : '0' + minDate.getDate(),
          monthStr =
            String(minDate.getMonth() + 1).length > 1
              ? minDate.getMonth() + 1
              : '0' + (minDate.getMonth() + 1);
        formattedMinDate = this.days[minDate.getDay()] + ', ' + dayStr + '. ' + monthStr + '.';
        const maxDayStr =
            String(maxDate.getDate()).length > 1 ? maxDate.getDate() : '0' + maxDate.getDate(),
          maxMonthStr =
            String(maxDate.getMonth() + 1).length > 1
              ? maxDate.getMonth() + 1
              : '0' + (maxDate.getMonth() + 1);
        formattedMaxDate =
          this.days[maxDate.getDay()] + ', ' + maxDayStr + '. ' + maxMonthStr + '.';
      } else if (this.dateFormat === 'dd_mm_numeric') {
        const dayStr =
            String(minDate.getDate()).length > 1 ? minDate.getDate() : '0' + minDate.getDate(),
          monthStr =
            String(minDate.getMonth() + 1).length > 1
              ? minDate.getMonth() + 1
              : '0' + (minDate.getMonth() + 1);
        formattedMinDate = dayStr + '. ' + monthStr + '.';
        const maxDayStr =
            String(maxDate.getDate()).length > 1 ? maxDate.getDate() : '0' + maxDate.getDate(),
          maxMonthStr =
            String(maxDate.getMonth() + 1).length > 1
              ? maxDate.getMonth() + 1
              : '0' + (maxDate.getMonth() + 1);
        formattedMaxDate = maxDayStr + '. ' + maxMonthStr + '.';
      } else
        ((formattedMinDate =
          this.days[minDate.getDay()] +
          ', ' +
          this.months[minDate.getMonth()] +
          ' ' +
          minDate.getDate() +
          minSuffix),
          (formattedMaxDate =
            this.days[maxDate.getDay()] +
            ', ' +
            this.months[maxDate.getMonth()] +
            ' ' +
            maxDate.getDate() +
            maxSuffix));
      const finalText = textTemplate
        .replace('[start_date]', formattedMinDate)
        .replace('[end_date]', formattedMaxDate);
      el.innerHTML = finalText;
    });
  }
  rearrangeDays(daysArr) {
    return (daysArr.unshift(daysArr[6]), (daysArr.length = 7), daysArr);
  }
}
customElements.define('dynamic-dates', DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    (super(),
      (this.isAfterScroll = this.dataset.afterScroll === 'true'),
      (this.isScrollBtn = this.dataset.scrollBtn === 'true'),
      (this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section)),
      (this.floatingBtns = document.querySelectorAll('.floating-btn')),
      this.footerSpacing(),
      this.isAfterScroll
        ? this.mainAtcBtn &&
          (this.checkATCScroll(),
          document.addEventListener('scroll', this.checkATCScroll.bind(this)))
        : this.floatingBtns.forEach((btn) => {
            btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
          }),
      this.isScrollBtn &&
        ((this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn')),
        (this.scrollDestination = document.querySelector(
          '' + this.dataset.scrollDestination.replace('id', this.dataset.section)
        )),
        this.scrollBtn &&
          this.scrollDestination &&
          this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this))));
  }
  checkATCScroll() {
    (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = 'none'), (this.scrolledPast = !0))
      : ((this.style.transform = ''), (this.scrolledPast = !1)),
      this.floatingBtns.forEach((btn) => {
        this.scrolledPast
          ? btn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px')
          : btn.style.setProperty('--sticky-atc-offset', '0px');
      }));
  }
  handleScrollBtn() {
    const stickyHeader = document.querySelector('sticky-header'),
      headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - headerHeight - 15,
      behavior: 'smooth',
    });
  }
  footerSpacing() {
    document.body.style.paddingBottom = this.clientHeight - 1 + 'px';
  }
}
(customElements.define('sticky-atc', StickyAtc),
  (function () {
    var shopifyStr = 'shopify';
    window.location.hostname.includes(shopifyStr) ||
      (document.querySelector('.main-product-form') &&
        (document.querySelector('.main-product-form').isCartUpsell = !0));
  })());
class BundleDeals extends HTMLElement {
  constructor() {
    (super(),
      (this.productContainers = this.querySelectorAll('.bundle-deals__product-js')),
      (this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container-js')),
      (this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img-js')),
      (this.checkboxes = this.querySelectorAll('.bundle-deals__checkbox-js')),
      (this.variantPickers = this.querySelectorAll('.bundle-deals__variant-selects-js')),
      (this.prices = this.querySelectorAll('.bundle-deals__price-js')),
      (this.comparePrices = this.querySelectorAll('.bundle-deals__compare-price-js')),
      (this.totalPrice = this.querySelector('.bundle-deals__total-price-js')),
      (this.totalComparePrice = this.querySelector('.bundle-deals__total-compare-price-js')),
      (this.updatePrices = this.dataset.updatePrices === 'true'),
      (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
      (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
      (this.currencySymbol = this.dataset.currencySymbol),
      (this.selectedVariants = {
        id_1: null,
        id_2: null,
        id_3: null,
        id_4: null,
        id_5: null,
      }),
      (this.formVariants = []),
      this.initIds(),
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      }),
      this.variantPickers.forEach((variantPicker) => {
        variantPicker.addEventListener('change', this.handleSelectChange.bind(this));
      }));
  }
  initIds() {
    (this.checkboxes.forEach((checkbox) => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        id: checkbox.dataset.id,
        price: checkbox.dataset.price,
        comparePrice: checkbox.dataset.comparePrice,
        checked: !0,
      };
    }),
      this.updateFormIds());
  }
  handleCheckboxChange(changeEvent) {
    const checkbox = changeEvent.currentTarget,
      isChecked = checkbox.checked,
      idx = parseInt(checkbox.dataset.index);
    this.selectedVariants[checkbox.dataset.idIndex].checked = isChecked;
    const productContainer = this.productContainers[idx],
      selects = productContainer.querySelectorAll('select');
    (isChecked
      ? (this.mediaItemContainers[idx].classList.remove('bundle-deals__media-item--disabled'),
        productContainer.classList.remove('bundle-deals__product--deselected'),
        selects.forEach((select) => {
          select.removeAttribute('disabled');
        }))
      : (this.mediaItemContainers[idx].classList.add('bundle-deals__media-item--disabled'),
        productContainer.classList.add('bundle-deals__product--deselected'),
        selects.forEach((select) => {
          select.setAttribute('disabled', '');
        })),
      this.updateFormIds(),
      this.updatePrices && this.updateTotalPrice());
  }
  handleSelectChange(changeEvent) {
    const variantPicker = changeEvent.currentTarget,
      idx = parseInt(variantPicker.dataset.index),
      selectedValues = Array.from(
        variantPicker.querySelectorAll('select'),
        (selectEl) => selectEl.value
      ),
      selectedVariant = JSON.parse(
        variantPicker.querySelector('[type="application/json"]').textContent
      ).find((variant) => !variant.options.map((opt, i) => selectedValues[i] === opt).includes(!1));
    let {
      price: price,
      compare_at_price: compareAtPrice,
      featured_image: featuredImage,
    } = selectedVariant;
    price = parseInt(price);
    let compareAtPriceInt = parseInt(compareAtPrice);
    featuredImage && (featuredImage = featuredImage.src);
    const variantId = selectedVariant.id;
    ((this.selectedVariants[variantPicker.dataset.idIndex].id = variantId),
      (this.selectedVariants[variantPicker.dataset.idIndex].price = price),
      (this.selectedVariants[variantPicker.dataset.idIndex].comparePrice = compareAtPriceInt),
      this.updateFormIds(),
      this.updatePrices &&
        ((this.prices[idx].innerHTML = this.currencySymbol + (price / 100).toFixed(2)),
        compareAtPriceInt > price
          ? (this.comparePrices[idx].innerHTML =
              this.currencySymbol + (compareAtPriceInt / 100).toFixed(2))
          : (this.comparePrices[idx].innerHTML = ''),
        this.updateTotalPrice()),
      featuredImage &&
        featuredImage.length > 0 &&
        this.mediaItemImgs[idx] &&
        (this.mediaItemImgs[idx].src = featuredImage));
  }
  updateFormIds() {
    const formVariants = [],
      selectedVariants = this.selectedVariants;
    for (const key in selectedVariants) {
      const variantData = selectedVariants[key];
      if (variantData != null && variantData.checked) {
        const existingIdx = formVariants.findIndex((item) => item.id === variantData.id);
        existingIdx < 0
          ? formVariants.unshift({ id: variantData.id, quantity: 1 })
          : (formVariants[existingIdx].quantity += 1);
      }
    }
    this.formVariants = formVariants;
  }
  updateTotalPrice() {
    const prices = [],
      comparePrices = [],
      selectedVariants = this.selectedVariants;
    for (const key in selectedVariants) {
      const variantData = selectedVariants[key];
      variantData != null &&
        variantData.checked &&
        (prices.push(parseInt(variantData.price)),
        comparePrices.push(parseInt(variantData.comparePrice)));
    }
    const totalPrice =
        prices.reduce((acc, price) => acc + price, 0) * this.percentageLeft - this.fixedDiscount,
      totalComparePrice = comparePrices.reduce((acc, price) => acc + price, 0);
    ((this.totalPrice.innerHTML = this.currencySymbol + (totalPrice / 100).toFixed(2)),
      totalComparePrice > totalPrice
        ? (this.totalComparePrice.innerHTML =
            this.currencySymbol + (totalComparePrice / 100).toFixed(2))
        : (this.totalComparePrice.innerHTML = ''));
  }
}
customElements.define('bundle-deals', BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll('.quantity-break');
    this.jsonData = this.querySelector('[type="application/json"]');
    this.hasVariants = this.jsonData ? this.jsonData.dataset.hasVariants === 'true' : false;
    this.selectedVariants = { input_1: [], input_2: [], input_3: [], input_4: [] };
    this.formVariants = [];
    this.selectedQuantity = 1;
    const checkedInput = this.querySelector('input[checked]');
    if (checkedInput) this.selectedQuantity = parseInt(checkedInput.value);
    this.variantSelects = this.querySelectorAll('.quantity-break__selector-item');
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.moneyFormat = this.dataset.moneyFormat;
    this._internalVariantUpdate = false;
    this.hasVariants && this.initVariants();
    this.inputs.forEach((input) => input.addEventListener('change', this.handleChange.bind(this)));
    this.variantSelects.forEach((variantSelect) =>
      variantSelect.addEventListener('change', this.handleSelectChange.bind(this))
    );
  }
  handleSelectChange(changeEvent) {
    const variantPicker = changeEvent.currentTarget,
      selectedValues = Array.from(
        variantPicker.querySelectorAll('select'),
        (select) => select.value
      ),
      selectedVariant = this.getVariantData().find(
        (variant) => !variant.options.map((opt, i) => selectedValues[i] === opt).includes(!1)
      );
    variantPicker.dataset.selectedId = selectedVariant.id;
    const selectIdx = variantPicker.dataset.selectIndex,
      breakLabel = variantPicker.closest('.quantity-break'),
      inputKey = breakLabel.dataset.input;
    this.selectedVariants[inputKey][selectIdx] = selectedVariant.id;
    this.formVariants = this.selectedVariants[inputKey];
    if (this.selectedQuantity === 1) this._syncNativeSelector(selectedVariant);
    else this.updateMedia(selectedVariant);
    if (!this.updatePrices) return;
    var totalPrice = 0,
      totalComparePrice = 0;
    const quantity = parseFloat(breakLabel.dataset.quantity);
    for (let i = 0; i < quantity; i++) {
      const vid = parseInt(this.selectedVariants[inputKey][i]),
        variant = this.getVariantData().find((v) => parseInt(v.id) === vid);
      if (!variant) return;
      totalPrice += variant.price;
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? (totalComparePrice += variant.compare_at_price)
        : (totalComparePrice += variant.price);
    }
    const avgUnitPrice = totalPrice / quantity;
    totalPrice = Math.round(totalPrice - this._calcOptimalSavings(quantity, avgUnitPrice));
    const priceEl = breakLabel.querySelector('.quantity-break__price');
    const comparePriceEl = breakLabel.querySelector('.quantity-break__compare-price');
    if (priceEl) priceEl.textContent = formatMoney(totalPrice, this.moneyFormat, !0);
    if (comparePriceEl) {
      comparePriceEl.textContent = formatMoney(totalComparePrice, this.moneyFormat, !0);
      comparePriceEl.classList.toggle('hidden', totalComparePrice <= totalPrice);
    }
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
  initVariants() {
    this.hasVariants &&
      (this.labels.forEach((label) => {
        if (label.querySelector('.quantity-break__variants')) {
          let selectedIds = [];
          (label.querySelectorAll('.quantity-break__selector-item').forEach((selectorItem) => {
            selectedIds.push(selectorItem.dataset.selectedId);
          }),
            (this.selectedVariants[label.dataset.input] = selectedIds));
        }
      }),
      (this.formVariants = []));
  }
  updateMedia(variant) {
    if (!variant || !variant.featured_media) return;
    document
      .querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]')
      .forEach((gallery) =>
        gallery.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, !0)
      );
  }
  handleChange(changeEvent) {
    const quantity = parseInt(changeEvent.target.value);
    ((this.selectedQuantity = quantity),
      this.hasVariants &&
        (this.formVariants = this.selectedVariants[changeEvent.target.dataset.input]),
      this.quantityGifts && this.quantityGifts.unlockGifts(quantity));
  }
  toggleMainVariantSelector(hidden) {
    const selector = document.querySelector(
      `variant-selects[data-section="${this.dataset.section}"], variant-radios[data-section="${this.dataset.section}"]`
    );
    if (!selector) return;
    if (hidden) selector.removeAttribute('data-qb-visible');
    else selector.setAttribute('data-qb-visible', '');
  }
  connectedCallback() {
    this.loadFromApi();
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event.data.sectionId !== this.dataset.section) return;
      if (this._internalVariantUpdate) return;
      if (event.data.variant) {
        this.dataset.variantId = event.data.variant.id;
        this.loadFromApi();
      }
    });
  }
  _calcOptimalSavings(quantity, unitPrice) {
    const tiers = this.discounts || [];
    if (tiers.length === 0) return 0;
    const dp = new Array(quantity + 1).fill(0);
    for (let q = 1; q <= quantity; q++) {
      for (const tier of tiers) {
        if (tier.quantity <= q) {
          const groupSavings =
            unitPrice * tier.quantity * ((tier.percentageOff || 0) / 100) +
            (tier.fixedAmountOff || 0) * 100;
          const candidate = dp[q - tier.quantity] + groupSavings;
          if (candidate > dp[q]) dp[q] = candidate;
        }
      }
    }
    return dp[quantity];
  }
  _syncNativeSelector(variant) {
    const nativeSelector = document.querySelector(
      `variant-selects[data-section="${this.dataset.section}"]`
    );
    if (!nativeSelector || !variant) return;
    this._internalVariantUpdate = true;
    nativeSelector.querySelectorAll('.product-form__input').forEach((inputEl, i) => {
      const typeEl = inputEl.querySelector('.product-form__input__type');
      const type = typeEl ? typeEl.dataset.type : '';
      const optionValue = variant.options[i];
      if (!optionValue) return;
      if (type === 'dropdown' || type === 'dropdwon') {
        const select = inputEl.querySelector('select');
        if (select) select.value = optionValue;
      } else {
        const radio = inputEl.querySelector(
          `input[type="radio"][value="${CSS.escape(optionValue)}"]`
        );
        if (radio) radio.checked = true;
      }
    });
    nativeSelector.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(() => {
      this._internalVariantUpdate = false;
    }, 100);
  }
  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }
  async loadFromApi() {
    const variantId = parseInt(this.dataset.variantId);
    const variant =
      this.getVariantData().find((v) => v.id === variantId) || this.getVariantData()[0];
    if (!variant) return;
    try {
      const productId = this.dataset.productId;
      const storeId = window.Shopify?.shop;
      const data = await this.fetchDiscountData(productId, storeId);
      const standardQty = document.getElementById('Quantity-Form-' + this.dataset.section);
      if (data.isDisable || !Array.isArray(data.discounts) || data.discounts.length === 0) {
        this.style.display = 'none';
        if (standardQty) standardQty.style.display = '';
        this.toggleMainVariantSelector(false);
        return;
      }
      this.style.display = '';
      if (standardQty) standardQty.style.display = 'none';
      this.renderOptions(data.headline, data.discounts, variant);
      this.reinitialize();
    } catch (e) {
      console.error('Quantity discount API error:', e);
      this.style.display = 'none';
      const standardQty = document.getElementById('Quantity-Form-' + this.dataset.section);
      if (standardQty) standardQty.style.display = '';
      this.toggleMainVariantSelector(false);
    }
  }
  async fetchDiscountData(productId, storeId) {
    const params = new URLSearchParams({ productId, shop: storeId });
    const baseUrl = window?.BASE_URL || 'https://api.thenexvolt.com/api/v2';
    const res = await fetch(`${baseUrl}/storefront/stores/product?${params}`);
    if (!res.ok) throw new Error(`Discount API error: ${res.status}`);
    const json = await res.json();
    return (json && json.data && json.data.bundle) || {};
  }
  renderOptions(headline, discounts, variant) {
    if (!Array.isArray(discounts) || discounts.length === 0 || !variant) return;
    const formId = this.dataset.formId;
    const container = this.querySelector('.quantity-breaks-container');
    if (!container) return;
    const titleEl = this.querySelector('.quantity-breaks__title');
    if (headline) {
      if (titleEl) {
        titleEl.querySelector('span:nth-child(2)').textContent = headline;
      } else {
        const h3 = document.createElement('h3');
        h3.className = 'quantity-breaks__title flex-center center';
        h3.innerHTML = `<span></span><span>${headline}</span><span></span>`;
        this.insertBefore(h3, container);
      }
    } else if (titleEl) {
      titleEl.remove();
    }
    this.discounts = discounts;
    const hasBadgeAny = discounts.some((o) => o.badge);
    if (hasBadgeAny) this.classList.add('quantity-breaks--has-badge');
    this.style.setProperty('--items-count', discounts.length);
    const unitPrice = variant.price;
    const unitComparePrice =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? variant.compare_at_price
        : variant.price;
    container.innerHTML = discounts
      .map((option, i) => {
        const idx = i + 1;
        const inputKey = `input_${idx}`;
        const savings = this._calcOptimalSavings(option.quantity, unitPrice);
        const price = Math.round(unitPrice * option.quantity - savings);
        const comparePrice = unitComparePrice * option.quantity;
        const hasBadge = !!option.badge;
        const fmtPrice = formatMoney(price, this.moneyFormat, true);
        const fmtComparePrice = formatMoney(comparePrice, this.moneyFormat, true);
        return `
          <input
            id="quantity${idx}"
            aria-label="Quantity"
            type="radio"
            name="quantity"
            value="${option.quantity}"
            form="${formId}"
            ${option.preselected ? 'checked' : ''}
            data-input="${inputKey}"
          >
          <label
            for="quantity${idx}"
            class="quantity-break${hasBadge ? ' quantity-break--badge' : ' quantity-break--no-badge'}"
            data-quantity="${option.quantity}"
            data-input="${inputKey}"
          >
            ${hasBadge ? `<p class="quantity-break__badge">${option.badge}</p>` : ''}
            <div class="quantity-break__content">
              <div class="quantity-break__left">
                <span class="quantity-break__label">
                  ${option.label ? `<span class="quantity-break__label-text">${option.label}</span>` : ''}
                  ${option.benefit ? `<span class="quantity-break__benefit">${option.benefit}</span>` : ''}
                </span>
                ${option.caption ? `<span class="quantity-break__caption">${option.caption}</span>` : ''}
              </div>
              <div class="quantity-break__right">
                <span class="quantity-break__price">${fmtPrice}</span>
                <span class="quantity-break__compare-price${comparePrice > price ? '' : ' hidden'}">${fmtComparePrice}</span>
              </div>
            </div>
            ${this.hasVariants ? this.buildVariantSelectorHtml(option.quantity, this.dataset.variantId) : ''}
          </label>`;
      })
      .join('');
  }
  buildVariantSelectorHtml(quantity, currentVariantId) {
    const variants = this.getVariantData();
    const optionNames = JSON.parse(this.dataset.options || '[]');
    const optionValues = [
      [...new Set(variants.map((v) => v.option1).filter(Boolean))],
      [...new Set(variants.map((v) => v.option2).filter(Boolean))],
      [...new Set(variants.map((v) => v.option3).filter(Boolean))],
    ].filter((arr) => arr.length > 0);
    if (optionValues.length === 0) return '';
    const currentVariant = variants.find((v) => v.id == currentVariantId) || variants[0];
    const currentOptions = currentVariant ? currentVariant.options : [];
    const caretSvg = `<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`;
    let html = '<div class="quantity-break__variants">';
    for (let slotIdx = 0; slotIdx < quantity; slotIdx++) {
      html += `<div class="quantity-break__selector-item" data-select-index="${slotIdx}" data-selected-id="${currentVariant ? currentVariant.id : ''}">`;
      html += `<span class="quantity-break__selector-item__number">#${slotIdx + 1}</span>`;
      optionValues.forEach((values, optIdx) => {
        const optionName = optionNames[optIdx] || `Option ${optIdx + 1}`;
        const selectedValue = currentOptions[optIdx] || values[0];
        html += `<div class="select select--small no-background">`;
        html += `<select class="quantity-break__variant-select select__select variant-dropdown" name="options[${optionName}]" data-product-id="${currentVariant ? currentVariant.id : ''}">`;
        values.forEach((value) => {
          html += `<option value="${value}"${value === selectedValue ? ' selected' : ''}>${value}</option>`;
        });
        html += `</select>${caretSvg}</div>`;
      });
      html += '</div>';
    }
    html += '</div>';
    return html;
  }
  reinitialize() {
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll('.quantity-break');
    this.variantSelects = this.querySelectorAll('.quantity-break__selector-item');
    const checkedInput = this.querySelector('input[name="quantity"]:checked');
    this.selectedQuantity = checkedInput ? parseInt(checkedInput.value) : 1;
    if (this.hasVariants) {
      this.initVariants();
      if (checkedInput) {
        this.formVariants = this.selectedVariants[checkedInput.dataset.input] || [];
      }
    }
    if (this.hasVariants) this.toggleMainVariantSelector(true);
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
    });
    this.variantSelects.forEach((variantSelect) => {
      variantSelect.addEventListener('change', this.handleSelectChange.bind(this));
    });
  }
}
customElements.define('quantity-breaks', QuantityBreaks);
function metafieldPoly() {}
class QuantityGifts extends HTMLElement {
  constructor() {
    (super(),
      (this.gifts = this.querySelectorAll('.quantity-gift')),
      (this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section)),
      (this.quantitySelector = document.getElementById('Quantity-Form--' + this.dataset.section)),
      (this.unlockedItems = []),
      this.initUnlock());
  }
  initUnlock() {
    let currentQty = 1;
    if (this.quantityBreaks) currentQty = parseInt(this.quantityBreaks.selectedQuantity);
    else if (this.quantitySelector) {
      const qtyInput = this.quantitySelector.querySelector('input[name="quantity"]');
      currentQty = parseInt(qtyInput.value);
    }
    this.unlockGifts(currentQty);
  }
  unlockGifts(quantity) {
    ((this.unlockedItems = []),
      this.gifts.forEach((gift) => {
        parseInt(gift.dataset.quantity) <= quantity
          ? (gift.classList.add('quantity-gift--unlocked'),
            (gift.dataset.unlocked = 'true'),
            this.unlockedItems.unshift(gift.dataset.product))
          : (gift.classList.remove('quantity-gift--unlocked'), (gift.dataset.unlocked = 'false'));
      }));
  }
}
customElements.define('quantity-gifts', QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    (super(),
      (this.image = this.querySelector('.upsell__image__img')),
      (this.toggleBtn = this.querySelector('.upsell-toggle-btn')),
      (this.variantSelects = this.querySelector('.upsell__variant-picker')),
      (this.variantSelectElements = this.querySelectorAll('.select__select')),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.updatePrices = this.dataset.updatePrices === 'true'),
      this.updatePrices &&
        ((this.price = parseInt(this.dataset.price)),
        (this.comparePrice = parseInt(this.dataset.comparePrice)),
        (this.priceSpan = this.querySelector('.upsell__price .regular-price')),
        (this.comparePriceSpan = this.querySelector('.upsell__price .compare-price')),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat),
        (this.isMainOfferItem = this.dataset.mainOfferItem === 'true'),
        this.isMainOfferItem &&
          (this.mainOfferContainer = document.querySelector(
            '#MainBundleOffer-' + this.dataset.section
          ))),
      this.toggleBtn && this.toggleBtn.addEventListener('click', this.handleToggle.bind(this)),
      this.variantSelects &&
        this.variantSelects.addEventListener('change', this.handleSelectChange.bind(this)));
  }
  handleToggle(clickEvent) {
    clickEvent.target.nodeName.toLowerCase() === 'select' ||
      clickEvent.target.nodeName.toLowerCase() === 'option' ||
      (this.dataset.selected === 'true'
        ? (this.dataset.selected = 'false')
        : (this.dataset.selected = 'true'));
  }
  handleSelectChange(changeEvent) {
    const selectedValues = Array.from(
        changeEvent.currentTarget.querySelectorAll('select'),
        (sel) => sel.value
      ),
      selectedVariant = this.getVariantData().find(
        (variant) => !variant.options.map((opt, i) => selectedValues[i] === opt).includes(!1)
      );
    (this.updatePrices &&
      ((this.price = selectedVariant.price * this.percentageLeft - this.fixedDiscount),
      (this.comparePrice = selectedVariant.price),
      selectedVariant.compare_at_price &&
        selectedVariant.compare_at_price > selectedVariant.price &&
        (this.comparePrice = selectedVariant.compare_at_price),
      displayPrices(
        this.price,
        this.comparePrice,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat
      )),
      this.image &&
        selectedVariant.featured_image &&
        (this.image.src = selectedVariant.featured_image.src),
      this.updateId(selectedVariant.id),
      this.isMainOfferItem &&
        this.mainOfferContainer.updateTotalPrices &&
        this.mainOfferContainer.updateTotalPrices());
  }
  updateId(variantId) {
    this.dataset.id = variantId;
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
}
customElements.define('product-info-upsell', ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    (super(),
      (this.cartDrawer = document.querySelector('cart-drawer')),
      (this.cartItems = this.cartDrawer.querySelector('cart-drawer-items')),
      (this.productForm = this.querySelector('product-form')),
      (this.idInput = this.productForm.querySelector('[name="id"]')));
  }
  handleToggle(clickEvent) {
    clickEvent.target.nodeName.toLowerCase() === 'select' ||
      clickEvent.target.nodeName.toLowerCase() === 'option' ||
      (this.dataset.selected === 'true'
        ? ((this.dataset.selected = 'false'), this.removeFromCart())
        : ((this.dataset.selected = 'true'), this.addToCart()));
  }
  addRemoveFromCart() {
    this.dataset.selected === 'true' && !this.cartDrawer.classList.contains('is-empty')
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle) ||
      (this.toggleBtn && this.toggleBtn.setAttribute('disabled', ''),
      this.variantSelectElements.forEach((selectEl) => {
        selectEl.setAttribute('disabled', '');
      }),
      this.productForm.handleSubmit());
  }
  removeFromCart() {
    const cartItem = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
    !cartItem ||
      !this.cartItems ||
      (this.toggleBtn && this.toggleBtn.setAttribute('disabled', ''),
      this.variantSelectElements.forEach((selectEl) => {
        selectEl.setAttribute('disabled', '');
      }),
      this.cartItems.updateQuantity(cartItem.dataset.index, 0));
  }
  updateId(variantId) {
    ((this.dataset.id = variantId),
      (this.idInput.value = variantId),
      this.dataset.selected === 'true' &&
        (this.selectTimeout && clearTimeout(this.selectTimeout),
        this.removeFromCart(),
        (this.selectTimeout = setTimeout(() => {
          this.addToCart();
        }, 1e3))));
  }
  getUpdateRequired() {
    const cartItem = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
    let updateRequired = !1;
    return (
      ((cartItem && this.dataset.selected === 'false') ||
        (!cartItem && this.dataset.selected === 'true')) &&
        (updateRequired = !0),
      updateRequired
    );
  }
}
customElements.define('cart-drawer-upsell', CartDrawerUpsell);
function displayPrices(price, comparePrice, priceEl, comparePriceEl, moneyFormat) {
  if (moneyFormat) {
    if (price && priceEl) {
      var formattedPrice = formatMoney(price, moneyFormat);
      priceEl.innerHTML = formattedPrice;
    }
    if (comparePrice && comparePriceEl) {
      var formattedComparePrice = formatMoney(comparePrice, moneyFormat);
      ((comparePriceEl.innerHTML = formattedComparePrice),
        comparePrice > price
          ? comparePriceEl.classList.remove('hidden')
          : comparePriceEl.classList.add('hidden'));
    }
  }
}
function initTrapFocus() {
  return (
    (isIe = !1),
    !(document.querySelector('footer') && document.querySelector('footer').dataset.type === null)
  );
}
function formatMoney(amount, format, trimZeroDecimals = !1) {
  typeof amount == 'string' && (amount = amount.replace('.', ''));
  var result = '',
    formatPattern = /\{\{\s*(\w+)\s*\}\}/,
    formatStr = format;
  function defaultTo(val, def) {
    return typeof val > 'u' ? def : val;
  }
  function numberWithFormat(cents, precision, thousands, decimal) {
    if (
      ((precision = defaultTo(precision, 2)),
      (thousands = defaultTo(thousands, ',')),
      (decimal = defaultTo(decimal, '.')),
      isNaN(cents) || cents == null)
    )
      return 0;
    cents = (cents / 100).toFixed(precision);
    var parts = cents.split('.'),
      intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      decPart = parts[1] ? decimal + parts[1] : '';
    return (trimZeroDecimals && decPart === decimal + '00' && (decPart = ''), intPart + decPart);
  }
  switch (formatStr.match(formatPattern)[1]) {
    case 'amount':
      result = numberWithFormat(amount, 2);
      break;
    case 'amount_no_decimals':
      result = numberWithFormat(amount, 0);
      break;
    case 'amount_with_comma_separator':
      result = numberWithFormat(amount, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      result = numberWithFormat(amount, 0, '.', ',');
      break;
  }
  return formatStr.replace(formatPattern, result);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define('cart-drawer-gift', CartDrawerGift);
function initToggleUpsells() {
  const cartDrawer = document.querySelector('cart-drawer');
  cartDrawer &&
    cartDrawer
      .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
      .forEach((upsell) => {
        upsell.addRemoveFromCart && upsell.addRemoveFromCart();
      });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    (super(),
      (this.offerItems = this.querySelectorAll('.main-offer-item')),
      (this.updatePrices = this.dataset.updatePrices === 'true'),
      this.updatePrices &&
        ((this.priceSpan = this.querySelector('.bundle-deals__total-price-js')),
        (this.comparePriceSpan = this.querySelector('.bundle-deals__total-compare-price-js')),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat)));
  }
  updateTotalPrices() {
    if (this.updatePrices) {
      var totalPrice = 0,
        totalComparePrice = 0;
      for (let i = 0; i < this.offerItems.length; i++)
        ((totalPrice += parseInt(this.offerItems[i].price)),
          (totalComparePrice += parseInt(this.offerItems[i].comparePrice)));
      ((totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount),
        displayPrices(
          totalPrice,
          totalComparePrice,
          this.priceSpan,
          this.comparePriceSpan,
          this.moneyFormat
        ));
    }
  }
}
customElements.define('main-bundle-offer', MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    (super(),
      (this.fieldName = this.dataset.name),
      (this.input = this.querySelector('[type="text"], [type="number"], textarea')),
      (this.inputRadios = this.querySelectorAll('[type="radio"]')),
      (this.select = this.querySelector('.select__select')),
      (this.productForm = document.getElementById('product-form-' + this.dataset.section)),
      (this.prevValue = this.dataset.defaultValue),
      (this.isRequired = this.dataset.required === 'true'),
      (this.isText = !0),
      (this.dataset.type === 'select' || this.dataset.type === 'pills') && (this.isText = !1),
      this.createInputs(),
      this.isRequired &&
        this.isText &&
        ((this.isValid = !0),
        (this.atcButtons = document.querySelectorAll('.main-product-atc')),
        (this.mainAtcButton = this.productForm.querySelector(
          '#ProductSubmitButton-' + this.dataset.section
        )),
        (this.mainAtcBtnLabel = this.mainAtcButton.querySelector('.main-addtocart__label')),
        (this.mainAtcBtnError = this.mainAtcButton.querySelector('.main-addtocart__error')),
        (this.atcErrorMsg = this.dataset.atcErrorMsg),
        (this.mainAtcButton.dataset.requiredFields =
          parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
        (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
        (this.applyStickyAtcError = this.dataset.applyStickyAtcError === 'true'),
        (this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section)),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector('.sticky-atc__label')),
          (this.stickyAtcBtnError = this.stickyAtcButton.querySelector('.sticky-atc__error')),
          (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
        this.validateValue(this.prevValue, null)),
      this.input && this.input.addEventListener('input', this.handleChange.bind(this)),
      this.inputRadios.forEach((radioInput) => {
        radioInput.addEventListener('input', this.handleChange.bind(this));
      }),
      this.select && this.select.addEventListener('change', this.handleChange.bind(this)));
  }
  handleChange(inputEvent) {
    const trimmedValue = inputEvent.target.value.trim();
    if (inputEvent.target.checkValidity()) this.prevValue = trimmedValue;
    else {
      inputEvent.target.value = this.prevValue;
      return;
    }
    ((this.productFormInput.value = trimmedValue),
      this.isRequired && this.isText && this.validateValue(trimmedValue, inputEvent.target));
  }
  validateValue(value, inputEl) {
    const isValid = value.length > 0;
    if (isValid === this.isValid) return;
    ((this.isValid = isValid),
      inputEl &&
        (this.isValid
          ? (inputEl.classList.remove('input--error'),
            (this.mainAtcButton.dataset.validFields =
              parseInt(this.mainAtcButton.dataset.validFields) + 1))
          : (inputEl.classList.add('input--error'),
            (this.mainAtcButton.dataset.validFields =
              parseInt(this.mainAtcButton.dataset.validFields) - 1))));
    const allFieldsValid =
        this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      isUnavailable = this.mainAtcButton.dataset.unavailable === 'true';
    (this.atcButtons.forEach((atcBtn) => {
      allFieldsValid && !isUnavailable
        ? atcBtn.removeAttribute('disabled')
        : atcBtn.setAttribute('disabled', '');
    }),
      this.atcErrorMsg.length !== 0 &&
        (allFieldsValid
          ? ((this.mainAtcBtnLabel.style.display = ''),
            (this.mainAtcBtnError.style.display = 'none'),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = ''),
              (this.stickyAtcBtnError.style.display = 'none')))
          : ((this.mainAtcBtnLabel.style.display = 'none'),
            (this.mainAtcBtnError.style.display = ''),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = 'none'),
              (this.stickyAtcBtnError.style.display = '')))));
  }
  createInputs() {
    ((this.productFormInput = document.createElement('input')),
      this.productFormInput.setAttribute('type', 'hidden'),
      this.productFormInput.setAttribute('name', 'properties[' + this.fieldName + ']'),
      (this.productFormInput.value = this.dataset.defaultValue),
      this.productForm.appendChild(this.productFormInput));
  }
}
customElements.define('custom-product-field', CustomProductField);
function playMedia() {
  serial || (serial = '');
}
class VariantSelects extends HTMLElement {
  constructor() {
    (super(),
      (this.secondarySelectSelector = 'StickyAtcVariantPicker-'),
      (this.secondarySelect = document.getElementById(
        '' + this.secondarySelectSelector + this.dataset.section
      )),
      (this.isSecondary = !1),
      (this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section)),
      (this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === 'true'),
      (this.prependMedia = this.dataset.disablePrepend != 'true'),
      this.hasQuantityBreaksPicker &&
        ((this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle),
        (this.quantityBreaksPickerDisplayedImages =
          this.dataset.quantityBreaksPickerDisplayedImages)),
      this.addEventListener('change', this.onVariantChange));
  }
  onVariantChange() {
    (this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, '', !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.updateShareUrl())
        : (this.toggleAddButton(!0, '', !0), this.setUnavailable()));
  }
  updateOptions() {
    const selectedOptions = [];
    (this.querySelectorAll('.product-form__input').forEach((inputEl) => {
      let value;
      const inputType = inputEl.querySelector('.product-form__input__type').dataset.type;
      (inputType == 'dropdown' || inputType == 'dropdwon'
        ? (value = inputEl.querySelector('select').value)
        : (value = inputEl.querySelector('input[type="radio"]:checked').value),
        selectedOptions.push(value));
    }),
      (this.options = selectedOptions));
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) => !variant.options.map((opt, i) => this.options[i] === opt).includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    document
      .querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]')
      .forEach((gallery) =>
        gallery.setActiveMedia(
          this.dataset.section + '-' + this.currentVariant.featured_media.id,
          this.prependMedia
        )
      );
    const productModal = document.querySelector(
      '#ProductModal-' + this.dataset.section + ' .product-media-modal__content'
    );
    if (!productModal) return;
    const variantMedia = productModal.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '"]'
    );
    productModal.prepend(variantMedia);
  }
  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === 'false' ||
      window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
  }
  updateShareUrl() {
    const shareEl = document.getElementById('Share-' + this.dataset.section);
    !shareEl ||
      !shareEl.updateUrl ||
      shareEl.updateUrl(
        '' + window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id
      );
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        '#product-form-' +
          this.dataset.section +
          ', #product-form-installment-' +
          this.dataset.section
      )
      .forEach((form) => {
        const idInput = form.querySelector('input[name="id"]');
        ((idInput.value = this.currentVariant.id),
          idInput.dispatchEvent(new Event('change', { bubbles: !0 })));
      });
  }
  updateVariantStatuses() {
    const firstOptionVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1
      ),
      inputEls = this.isSecondary
        ? [...this.secondarySelect.querySelectorAll('.product-form__input')]
        : [...this.querySelectorAll('.product-form__input')];
    inputEls.forEach((inputEl, i) => {
      if (i === 0) return;
      const radiosOrOptions = [...inputEl.querySelectorAll('input[type="radio"], option')],
        prevOptionVal = inputEls[i - 1].querySelector(':checked').value,
        availableOptions = firstOptionVariants
          .filter((variant) => variant.available && variant['option' + i] === prevOptionVal)
          .map((variant) => variant['option' + (i + 1)]);
      this.setInputAvailability(radiosOrOptions, availableOptions);
    });
  }
  setInputAvailability(inputs, availableVals) {
    inputs.forEach((input) => {
      input.nodeName === 'option'
        ? availableVals.includes(input.getAttribute('value'))
          ? (input.innerText = input.getAttribute('value'))
          : (input.innerText = window.variantStrings.unavailable_with_option.replace(
              '[value]',
              input.getAttribute('value')
            ))
        : availableVals.includes(input.getAttribute('value'))
          ? input.classList.remove('disabled')
          : input.classList.add('disabled');
    });
  }
  updatePickupAvailability() {
    const pickupAvailEl = document.querySelector('pickup-availability');
    pickupAvailEl &&
      (this.currentVariant && this.currentVariant.available
        ? pickupAvailEl.fetchAvailability(this.currentVariant.id)
        : (pickupAvailEl.removeAttribute('available'), (pickupAvailEl.innerHTML = '')));
  }
  removeErrorMessage() {
    const sectionEl = this.closest('section');
    if (!sectionEl) return;
    const productForm = sectionEl.querySelector('product-form');
    productForm && productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const variantId = this.currentVariant.id,
      sectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      this.dataset.url +
        '?variant=' +
        variantId +
        '&section_id=' +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
    )
      .then((response) => response.text())
      .then((html) => {
        if (this.currentVariant.id !== variantId) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html'),
          priceEl = document.getElementById('price-' + this.dataset.section),
          newPriceEl = parsed.getElementById(
            'price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          separatePriceEl = document.getElementById(
            'sticky-atc-separate-price-' + this.dataset.section
          ),
          newSeparatePriceEl = parsed.getElementById(
            'sticky-atc-separate-price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          stickyPriceEl = document.getElementById('sticky-atc-price-' + this.dataset.section),
          newStickyPriceEl = parsed.getElementById(
            'sticky-atc-price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          stickyImgEl = document.getElementById('sticky-atc-image-' + this.dataset.section),
          newStickyImgEl = parsed.getElementById(
            'sticky-atc-image-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          mainAtcPriceEl = document.getElementById('main-addtocart-price-' + this.dataset.section),
          newMainAtcPriceEl = parsed.getElementById(
            'main-addtocart-price-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          customLabels = document.querySelectorAll(
            '[id^="custom-label-' + this.dataset.section + '"]'
          ),
          newCustomLabels = parsed.querySelectorAll(
            '[id^="custom-label-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
              '"]'
          ),
          newSkuEl = parsed.getElementById(
            'Sku-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          skuEl = document.getElementById('Sku-' + this.dataset.section),
          newInventoryEl = parsed.getElementById(
            'Inventory-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          ),
          inventoryEl = document.getElementById('Inventory-' + this.dataset.section);
        if (
          (priceEl && newPriceEl && (priceEl.innerHTML = newPriceEl.innerHTML),
          separatePriceEl &&
            newSeparatePriceEl &&
            (separatePriceEl.innerHTML = newSeparatePriceEl.innerHTML),
          stickyPriceEl &&
            newStickyPriceEl &&
            (stickyPriceEl.innerHTML = newStickyPriceEl.innerHTML),
          stickyImgEl && newStickyImgEl && (stickyImgEl.src = newStickyImgEl.src),
          newMainAtcPriceEl &&
            mainAtcPriceEl &&
            (mainAtcPriceEl.innerHTML = newMainAtcPriceEl.innerHTML),
          customLabels && newCustomLabels)
        )
          for (var i = 0; i < customLabels.length; i++)
            customLabels[i].innerHTML = newCustomLabels[i].innerHTML;
        if (
          (newInventoryEl && inventoryEl && (inventoryEl.innerHTML = newInventoryEl.innerHTML),
          newSkuEl &&
            skuEl &&
            ((skuEl.innerHTML = newSkuEl.innerHTML),
            skuEl.classList.toggle(
              'visibility-hidden',
              newSkuEl.classList.contains('visibility-hidden')
            )),
          this.QuantityBreaks)
        ) {
          const qtyBreaksEl = parsed.getElementById(
              'quantity-breaks-' +
                (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
            ),
            dynamicPrices = this.QuantityBreaks.querySelectorAll('.dynamic-price'),
            newDynamicPrices = qtyBreaksEl.querySelectorAll('.dynamic-price');
          for (let i = 0; i < dynamicPrices.length; i++)
            newDynamicPrices[i] && (dynamicPrices[i].innerHTML = newDynamicPrices[i].innerHTML);
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((variantSelect) => {
              variantSelect.dataset.selectedId = this.currentVariant.id;
            });
            const variantSelects = this.QuantityBreaks.querySelectorAll(
                '.quantity-break__variant-select'
              ),
              newVariantSelects = qtyBreaksEl.querySelectorAll('.quantity-break__variant-select');
            for (let i = 0; i < variantSelects.length; i++)
              newVariantSelects[i] &&
                (variantSelects[i].innerHTML = newVariantSelects[i].innerHTML);
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const qtyBreaksPickerEl = parsed.getElementById(
              'variant-selects-' +
                (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
            ),
            dynamicPrices = this.querySelectorAll('.dynamic-price'),
            newDynamicPrices = qtyBreaksPickerEl.querySelectorAll('.dynamic-price');
          for (let i = 0; i < dynamicPrices.length; i++)
            dynamicPrices[i].innerHTML = newDynamicPrices[i].innerHTML;
          if (
            this.quantityBreaksPickerStyle === 'vertical' &&
            this.quantityBreaksPickerDisplayedImages === 'variant_images'
          ) {
            const breakImages = this.querySelectorAll('.quantity-break__image img'),
              newBreakImages = qtyBreaksPickerEl.querySelectorAll('.quantity-break__image img');
            for (let i = 0; i < breakImages.length; i++) breakImages[i].src = newBreakImages[i].src;
          }
        }
        if (this.secondarySelect) {
          const secondarySelectEl = parsed.getElementById(
            '' +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
          );
          secondarySelectEl && (this.secondarySelect.innerHTML = secondarySelectEl.innerHTML);
        }
        const priceEl2 = document.getElementById('price-' + this.dataset.section);
        (priceEl2 && priceEl2.classList.remove('visibility-hidden'),
          inventoryEl &&
            inventoryEl.classList.toggle('visibility-hidden', newInventoryEl.innerText === ''));
        const submitBtn = parsed.getElementById('ProductSubmitButton-' + sectionId);
        (this.toggleAddButton(
          submitBtn ? submitBtn.hasAttribute('disabled') : !0,
          window.variantStrings.soldOut
        ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: sectionId,
              html: parsed,
              variant: this.currentVariant,
            },
          }));
      });
  }
  toggleAddButton(isDisabled = !0, label, removeDisabledAttr = !0) {
    const productForm = document.getElementById('product-form-' + this.dataset.section);
    if (!productForm) return;
    const addBtn = productForm.querySelector('[name="add"]'),
      addBtnLabel = productForm.querySelector('[name="add"] > .main-addtocart__label');
    const buyNowBtn = productForm.querySelector('#buy-now-btn'),
      buyNowBtnLabel = productForm.querySelector('#buy-now-btn > .main-addtocart__label');
    addBtn &&
      (isDisabled
        ? (addBtn.setAttribute('disabled', 'disabled'),
          addBtn.setAttribute('data-unavailable', 'true'),
          label && (addBtnLabel.textContent = label))
        : (addBtn.setAttribute('data-unavailable', 'false'),
          (addBtnLabel.textContent = window.variantStrings.addToCart),
          addBtn.dataset.requiredFields === addBtn.dataset.validFields &&
            addBtn.removeAttribute('disabled')));
    buyNowBtn &&
      (isDisabled
        ? (buyNowBtn.setAttribute('disabled', 'disabled'),
          buyNowBtn.setAttribute('data-unavailable', 'true'),
          label && (buyNowBtnLabel.textContent = label))
        : (buyNowBtn.setAttribute('data-unavailable', 'false'),
          (buyNowBtnLabel.textContent = 'PAY WITH DEBIT / CREDIT CARD'),
          buyNowBtn.dataset.requiredFields === buyNowBtn.dataset.validFields &&
            buyNowBtn.removeAttribute('disabled')));
  }
  setUnavailable() {
    const productForm = document.getElementById('product-form-' + this.dataset.section),
      addBtn = productForm.querySelector('[name="add"]'),
      addBtnLabel = productForm.querySelector('[name="add"] > .main-addtocart__label'),
      priceEl = document.getElementById('price-' + this.dataset.section),
      inventoryEl = document.getElementById('Inventory-' + this.dataset.section),
      skuEl = document.getElementById('Sku-' + this.dataset.section),
      buyNowBtnLabel = productForm.querySelector('#buy-now-btn > .main-addtocart__label');
    addBtn &&
      ((addBtnLabel.textContent = window.variantStrings.unavailable),
      (buyNowBtnLabel.textContent = window.variantStrings.unavailable),
      priceEl && priceEl.classList.add('visibility-hidden'),
      inventoryEl && inventoryEl.classList.add('visibility-hidden'),
      skuEl && skuEl.classList.add('visibility-hidden'));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
}
customElements.define('variant-selects', VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    (super(),
      (this.secondarySelectSelector = 'variant-selects-'),
      (this.secondarySelect = document.getElementById(
        '' + this.secondarySelectSelector + this.dataset.section
      )),
      (this.isSecondary = !0));
  }
  updateOptions() {
    this.options = this.querySelector('select').value.split(',');
  }
}
customElements.define('secondary-variant-select', SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    (super(),
      (this.secondarySelectSelector = 'variant-selects-'),
      (this.secondarySelect = document.getElementById(
        '' + this.secondarySelectSelector + this.dataset.section
      )),
      (this.isSecondary = !0));
  }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);
